import React from 'react'
import { message, Modal } from 'antd'
import { autorun, reaction } from 'mobx'
import Store, { AppConfig, AppStore, GameLibraryStore, HaiShaJsqStore, QueueStore } from './AppStore'
import { stringify } from 'querystring'
import { loadActivity23616Config } from 'src/pc/activity/23-6-16'
import {
  CreateOrderJavaHttpHS,
  createPayHS,
  DWbindWechat,
  DWCheckWeiXinLoginHttp,
  DWGetIsRealNameAuthHttp,
  DWMacLoginHttp,
  getIsNeedRealNameAuthHttpHS,
  getVipServiceOrderHS,
  grantCouponHS,
  isReceiveNewUserHS,
  queryUserMarkHS,
  UserInfoHS,
  UserInfoHSTemp,
  DWgetActivityUserPurchaseInfo,
  DWgetNeedJoinKaiheiCommunityIdsByUser,
} from 'src/commons/store/UserStore'
import { get3rdIdFromSetupName } from 'src/pc/utils/util'
import { checkDepositeOrderPayStatus, getUserInfo, loginSuccess, successByLoginPage } from './UserStore'
import {
  AbstractPolling,
  API_URL,
  bidStr,
  getOEMCMSProperty,
  isChangshaGJ,
  lidStr,
  getProductName,
} from 'src/commons/utils/Commons'
import { history, loadChannelConfigJava, loadChannelConfigPhp } from 'src/commons/utils/WebCommons'
import { getPhpToken } from 'src/pc/utils/auth'
import { getCommonPromise, CommonPromiseKeyMapping } from 'src/commons/utils'
import {
  DWAddGameHttp,
  DWGameDetailHttp,
  DWgetBargainConfig,
  DWgetUserGameStatus,
  ForbidInfoHS,
  depositAmountHS,
  GamePackageListHS,
  GamePlayInfoHS,
  getActive1ConfigHS,
  getGameLibraryByAppIdHS,
  getGameLibraryListHS,
  QueryQueueHS,
  RecentPlayGameHS,
  getActivityConfigInfoHS,
  getGoodsIdForHideOrder,
  DWGetGameLibraryInfoByGoodsId,
} from 'src/commons/store/GameStore'
import {
  activityStartGpGameHS,
  ChannelConfigHS,
  DWBeijingTime,
  DWbindInviter,
  DWCMSVersionHttp,
  DWGetModDataByModIdHttp,
  DWVipBindInviter,
  GetConfigByChannelHS,
  GetContactUrlHS,
  getGamePlayListHS,
  GetPreProcessHS,
  GetVipConfigJavaHS,
  GetVipInvitedUserPhoneHS,
  reportClientOpenHS,
  reportCloudArchivesDownloadNumHS,
  statisticsApiHS,
} from 'src/commons/store/BasisStore'
import {
  CompareVersion,
  DownloadClient,
  downUrl,
  GetChannel,
  GUID,
  recordLoginInfo,
  signatureEncode,
  BeijingTime,
  checkIsDouyinChannel,
} from 'src/commons/utils'
import { initPollModIds, ModDatas, useWaitModData } from '@hhpack/use-cms'
import {
  checkChargeDepositTips,
  GameAccountIsFullTitle,
  GameAccountIsInOffTime,
  JuvenileReminder,
  showNeedDeposit,
} from 'src/commons/utils/DOMUtils'
import { throttle } from 'lodash'
import { checkUserIsHaveQualification } from 'src/pc/components/active-war-order-modal'
import { checkYearUpdateForeverModal } from 'src/pc/components/expe-year-update-forever-modal'
import { checkUpdateVipModal } from 'src/pc/components/update-vip-modal'
import { awaitRealNameAuthModal } from 'src/pc/components/RealNameAuthModal'
import Cookies from 'js-cookie'
import DDModal from 'src/pc/components/DDModal'
import useQueue from 'src/pc/components/hooks/useQueue'
import CloudGameClientStore from 'src/pc/store/cloudGame/cloudGameClientStore'
import useCloudGameStart from 'src/pc/components/hooks/useCloudGameStart'
import moment from 'moment'

// 季卡会员，月卡会员，年卡会员的id
export const vipIdArr = ['prod', 'pre'].includes(process.env.BUILD_TYPE)
  ? [1578282999, 1578281728, 1578281618]
  : [1578281137, 1578039816, 1578039690]

export const CheckWeiXinLogin = AbstractPolling((state: string) => {
  return DWCheckWeiXinLoginHttp.Execute({ state, channel: GetChannel() })
})
export const CheckBindWeiXin = AbstractPolling(async (state: string) => {
  const data = await DWbindWechat.Execute({ state, channel: GetChannel() })
  return data
})
/** 实名认证和9+1活动弹框逻辑 */
/** @TODO */
export const authModalIsOpen = async () => {
  const showAuthModal = await isShowAuthModal(true)
  // if (window.location.pathname === '/' && !showAuthModal) {
  //   viewActiveModal()
  // }
}
/** 获取年卡送的加速器 */
export const getYearJsqDays = async () => {
  // 获取所有会员挡位
  const resultVipList = await getVipGoodsByChannel()
  const yearJsqDays = resultVipList.filter((item, index) => item.vipType === 'year')
  return {
    times: yearJsqDays[0]?.buyVipGetJsqTime,
    jsqName: yearJsqDays[0]?.buyVipGetJsqDesc,
  }
}

/** 获取当前渠道的所有会员商品 */
export const getVipGoodsByChannel = async (activityNo?: string, nofilter?: boolean) => {
  const vipListRes = await GetVipConfigJavaHS.Execute({ activityNo, channel: GetChannel() })
  if (nofilter) {
    return vipListRes.sort((a, b) => a.sort - b.sort)
  } else {
    return vipListRes.sort((a, b) => a.sort - b.sort).filter((d, i) => i < 3)
  }
}

/** 绑定邀请码逻辑 */
export const bindInviteCode = async (code: string, callback?: () => void) => {
  try {
    const bindInviterResult = await DWbindInviter.Execute({ inviterCode: code })
    const vipBindInviterResult = await DWVipBindInviter.Execute({ mobile: bindInviterResult, isNew: 1 })
    callback && callback()
    isLogged().then(token => {
      getUserInfo(token)
    })
    if (
      !vipBindInviterResult.discount &&
      !vipBindInviterResult.inviteeGivingVipDays &&
      !vipBindInviterResult.beInviteeGivingVipDays &&
      !vipBindInviterResult.beInviterGivingVipDays
    ) {
      message.success('绑定邀请人成功')
      return
    }
    AppStore.bindResult = vipBindInviterResult
    AppStore.bindInvitationCodeSuccessModal = true
  } catch (error) {
    message.error(error.message)
  }
}

export const loadInClientToken = () => {
  const Query = new URLSearchParams(location.search)
  const token = Query.get('token')
  if (token) {
    localStorage.setItem('php-token', token)
  }
}

/** 客户端打开上报 */
export const reportClientOpen = async () => {
  try {
    await reportClientOpenHS.Execute()
    AppStore.reportClientOpenResult = 'success'
  } catch (e) {
    AppStore.reportClientOpenResult = 'fail'
  }
}

export const checkLoginStatus = async () => {
  // const Query = new URLSearchParams(location.search)
  // const forcelogon = Query.get('forcelogon') || undefined
  // const Query = new URLSearchParams(location.search)
  // const token = Query.get('token')
  const token = getPhpToken()

  // const version = await getCMSVersion()
  // const forcedRes = await DWGetModDataByModIdHttp.Execute({ modId: 'simpleclient_forced_landing_channel', version })
  // let forcedMode: 'block' | 'white' = 'block'

  // if (forcedRes.datas.length > 0) {
  //   forcedMode = forcedRes.datas[0].properties.useBlacklist === '0' ? 'white' : 'block'

  // }

  // console.log(token, 'token', '1')
  // if (!forcelogon) {
  //   /** 打开广告弹框 */
  //   openNotification()
  // }
  // if (forcelogon) {
  //   localStorage.setItem('forcelogon', '1')
  // }
  if (token) {
    successByLoginPage(token)
    return
  }
  const Query = new URLSearchParams(window.location.search.substr(1, window.location.search.length))
  const deviceUid = Query.get('mid') || localStorage.getItem('mid') || ''
  /** mac地址自动登录 */
  if (window.FuluApp && deviceUid) {
    try {
      //查询渠道配置,是否开启mac登录 ,loadChannelConfig()有请求GetConfigByChannelHS，监听响应结果即可
      const enableMacLogin = await new Promise<boolean>(resolve => {
        const disposer = autorun(() => {
          if (GetConfigByChannelHS.SuccessResult || GetConfigByChannelHS.FailedResult) {
            disposer()
            resolve(!!GetConfigByChannelHS.SuccessResult?.enableMacLogin)
          }
        })
      })
      if (!enableMacLogin) {
        throw new Error('mac login disabled')
      }
      const time = new Date().getTime()
      //mac地址登录/注册
      const loginRes = await DWMacLoginHttp.Execute(
        {
          deviceUid,
          channel: GetChannel(),
        },
        {
          headers: {
            timestamp: String(time),
            signature: signatureEncode(deviceUid + '.' + time),
          },
        },
      )
      console.log('mac自动登录 success')
      recordLoginInfo(4, loginRes.is_new)
      successByLoginPage(loginRes.token)
      return
    } catch (e) {
      console.log('mac自动登录 err', e)
    }
  }
  window.FuluApp?.JSNotifyCppFunc('need_user_logon')
}

/** 万圣节活动编号 */
export const MIDAUTUMNFESTIVAL_ACTIVITY_NO = 'AT5532805947697972881'

/** 暑期活动编号 */
export const SUMMER_ACTIVITY_NO = 'AT5639000631950688550'

/** 独享优惠购CDK活动编号 */
export const CDK_DISCOUNT_ACTIVITY_NO = 'AT5739055105701958416'

/** 是否需要实名认证 */
export const isNeedIdcardAuth = async () => {
  const result = await getIsNeedRealNameAuthHttpHS.Execute()
  return result
}

/* 是否实名认证过 */
export const isShowAuthModal = async (showModal?: boolean) => {
  const token = getPhpToken()
  const result = await DWGetIsRealNameAuthHttp.Execute({ token })
  if (!result && showModal) {
    AppStore.realNameAuthModal = true
    return true
  }
  return false
}
/**关闭人工实名认证弹框*/
export const closeArtificialAuthModal = () => {
  AppStore.artificialAuthModal = false
  AppStore.realNameAuthModal = true
}
/* 关闭实名认证弹框 */
/** @TODO */
export const closeAuthModal = () => {
  AppStore.realNameAuthModal = false
  getCommonPromise(CommonPromiseKeyMapping.REAL_NAME_AUTH).resolve?.(false)
  //如果是首页关闭则需要关闭后打开活动窗口
  // if (window.location.pathname === '/') {
  //   viewActiveModal()
  // }
}
/* 判断是否未成年 */
export const JuvenileLimit = (age: number | null | undefined) => {
  if (age && age < 18) {
    JuvenileReminder()
    return true
  }
  return false
}

/*显示登录框*/
export const ShowLoginModal = () => {
  ShowPhoneLoginModal()
  // if (window.WxLogin && !AppStore.notViewWechatEntry.includes(GetChannel())) {
  //   ShowWeiXinLogin()
  // } else {
  //   ShowPhoneLoginModal()
  // }
}
/*显示手机验证码登录框*/
export const ShowPhoneLoginModal = () => {
  AppStore.LoginModalVisible = true
}
/*隐藏手机验证码登录框*/
export const HidePhoneLoginModal = () => {
  AppStore.LoginModalVisible = false
}
/*显示微信登录框*/
export const showWeiXinLogin = () => {
  AppStore.WeiXinLoginVisible = true
}
export const GetWeiXinLoginQRCode: {
  StopPolling?: Function
  Execute: (options?: { size: number }) => void
} = {
  Execute: options => {
    const zoom = localStorage.getItem('zoom') || '1'
    GetWeiXinLoginQRCode.StopPolling?.() //防止反复调用重复轮询
    AppStore.WeiXinLoginTimeout = false
    const state = GUID()
    window.setTimeout(() => {
      window.WxLogin!({
        self_redirect: true,
        id: 'WeiXinLogin',
        appid: 'wx0eb9a86b1e7c62b3',
        scope: 'snsapi_login',
        redirect_uri: `https://steam-api.99box.com/api/wechatLogin?env=${
          process.env.BUILD_TYPE.startsWith('pr') ? '' : 'test'
        }`,
        state,
        style: 'black',
        href: `data:text/css;base64,${window.btoa(`
          body {zoom: ${zoom} !important;color:#fff}
         .impowerBox .title {display: none;}
         .impowerBox .qrcode{width:${options?.size || 123}px;margin-top:0;border:none}
         .impowerBox .status {padding:0;}
         .impowerBox .status_succ, .status_fail {padding:0;width:${options?.size || 123}px;height:${
          options?.size || 123
}px;background:rgba(0,0,0,0.5);position:absolute;top:0;left:0;display:flex;align-items:center;flex-direction:column;justify-content:center;}
         .impowerBox .status_txt {position:absolute;bottom:-60px;}
         .impowerBox .status_txt h4 {color:#ffffff;font-size:13px;text-align:center;}
         .impowerBox .status_txt p {color:#ffffff;font-size:13px;text-align:center;white-space: nowrap;}
         .impowerBox .status_browser {display: none;}
         `)}`,
      })
    }, 200)
    GetWeiXinLoginQRCode.StopPolling = CheckWeiXinLogin(
      state,
      Result => {
        if (Result) {
          AppStore.WeChatLoginData = Result
          AppConfig.WeChatLoginUnionId = Result.unionid
          HidePhoneLoginModal()
          HideWeChatLogin()
          console.log(Result.token, '微信登录返回的token')
          if (Result.token) {
            loginSuccess(Result.token)
            // if (Result.is_new) {
            //   AppStore.inviteCodeModal = true
            // }
            return
          }
          if (process.env.BUILD_TYPE.startsWith('dev')) {
            Cookies.set('STATE', state, { domain: 'localhost' })
          } else {
            Cookies.set('STATE', state, { domain: '99box.com' })
          }
          loginSuccess('', true)
        }
      },
      () => {
        AppStore.WeiXinLoginTimeout = true
      },
    )
  },
}

export const HideWeChatLogin = () => {
  AppStore.WeiXinLoginVisible = false
  AppStore.WeiXinLoginTimeout = false
  AppStore.ShowBindWeiXin = false
  GetWeiXinLoginQRCode.StopPolling?.()
}

export const HideBindWeChat = () => {
  AppStore.bindWeiXinVisible = false
  AppStore.bindWeiXinTimeout = false
  getBindWeiXinQRCode.StopPolling?.()
}

export const gameStartingSuccess = (notHideCheckModal?: boolean) => {
  console.log('启动成功')

  GameLibraryStore.gameStartingTimer && window.clearTimeout(GameLibraryStore.gameStartingTimer)
  window.clearTimeout(doStartActivityGame.CheckTimer)
  if (!notHideCheckModal) {
    AppStore.CheckModalVisible = false
  }
  AppStore.minimizeGameCheckVisible = false

  const startSuccessNum = (Number(localStorage.getItem(`start-game-success-num`)) || 0) + 1
  localStorage.setItem('start-game-success-num', `${startSuccessNum}`)
  if (startSuccessNum >= 3) {
    checkYearUpdateForeverModal('start')
  }
  if (localStorage.getItem(`year-update-forever-modal-game`) !== '1') {
    AppStore.expeYearUpdateForeverModalTimer && window.clearTimeout(AppStore.expeYearUpdateForeverModalTimer)
    AppStore.expeYearUpdateForeverModalTimer = window.setTimeout(() => {
      checkYearUpdateForeverModal('game')
    }, 30 * 1000 * 60)
  }
}

/*隐藏检测弹出框*/
export const HideCheckModal = () => {
  GameLibraryStore.gameStartingTimer && window.clearTimeout(GameLibraryStore.gameStartingTimer)
  GameLibraryStore.gameRunStatus = 'stop'
  window.clearTimeout(doStartActivityGame.CheckTimer)
  window.FuluApp?.JSNotifyCppFunc('exit_game', 0)
  AppStore.CheckModalVisible = false
  AppStore.minimizeGameCheckVisible = false
}

export const getBindWeiXinQRCode: {
  StopPolling?: Function
  Execute: (options?: { size: number }) => void
} = {
  Execute: options => {
    const zoom = localStorage.getItem('zoom') || '1'
    getBindWeiXinQRCode.StopPolling?.() //防止反复调用重复轮询
    AppStore.bindWeiXinTimeout = false
    const state = GUID()
    window.setTimeout(() => {
      window.WxLogin!({
        self_redirect: true,
        id: 'WeiXinLogin',
        appid: 'wx0eb9a86b1e7c62b3',
        scope: 'snsapi_login',
        redirect_uri: `https://steam-api.99box.com/api/wechatLogin?env=${
          process.env.BUILD_TYPE.startsWith('pr') ? '' : 'test'
        }`,
        state,
        style: 'black',
        href: `data:text/css;base64,${window.btoa(`
          body {zoom: ${zoom} !important;color:#fff}
         .impowerBox .title {display: none;}
         .impowerBox .qrcode{width:${options?.size || 162}px;margin-top:0;border:none}
         .impowerBox .status_browser {display: none;}
         `)}`,
      })
    }, 200)
    getBindWeiXinQRCode.StopPolling = CheckBindWeiXin(
      state,
      Result => {
        if (Result.code === '1') {
          HideBindWeChat()
          message.success('绑定成功，可使用微信扫码快捷登录')
          const token = getPhpToken()
          token && getUserInfo(token)
        }
        if (Result.code === 'wechat_registered') {
          HideBindWeChat()
          message.error(Result.message)
        }
      },
      () => {
        AppStore.bindWeiXinTimeout = true
      },
    )
  },
}

/*打开应用程序*/
export const OpenProgram = (Name: string, value: string) => {
  if (window.FuluApp) {
    window.FuluApp.JSNotifyCppFunc('open_local_process', Name, value)
  } else {
    needClient()
  }
}

/*打开壁纸*/
export const OpenWallpaperApp = () => {
  isLogged().then(token => {
    OpenProgram('wallpaperUI.exe', token)
  })
}

/*动态壁纸保存 token*/
export const WallpaperSaveToken = () => {
  const Query = new URLSearchParams(window.location.search.substr(1, window.location.search.length))
  const token = Query.get('token')
  if (token) {
    // GetBoxWebPower.Execute({ token })
    localStorage.setItem('token', token)
  }
}

/*打开客服*/
export const OpenCustomerService = async (flag?: boolean, orderNo?: string, type?: number) => {
  if (AppStore.standbyHelp) {
    const result = `https://help.99box.com?appName=游戏管家`
    if (window.FuluApp) {
      if (flag) {
        window.FuluApp!.JSNotifyCppFunc('online_customer_service', result)
      } else {
        isLogged().then(() => {
          window.FuluApp!.JSNotifyCppFunc('online_customer_service', result)
        })
      }
    } else {
      window.open(result, '_blank')
    }
  } else {
    window?.ddmt?.reportServiceEventReview?.()
    let result: ContactInfo | null = null
    try {
      result = await GetContactUrlHS.Execute({
        type: isChangshaGJ ? 23 : type || 2,
        mtKey: localStorage.getItem('ddmt-i') || '',
        token: getPhpToken() || '',
        gameNo: orderNo,
      })
    } catch (error) {}
    result = result || { url: 'https://cschat-ccs.cdn.namejin.com/index.htm?tntInstId=_1KlnA7c&scene=SCE00004763' }

    if (window.FuluApp) {
      if (flag) {
        window.FuluApp!.JSNotifyCppFunc('online_customer_service', result.url, result.jsFile)
      } else {
        isLogged().then(() => {
          window.FuluApp!.JSNotifyCppFunc('online_customer_service', result?.url || '', result?.jsFile)
        })
      }
    } else {
      window.open(result.url, '_blank')
    }
  }
}

/*打开vip客服*/
export const OpenVipCustomerService = async (orderNo?: string) => {
  let newWindow: Window | null
  const token = await isLogged()
  try {
    const result = await GetContactUrlHS.Execute({
      token,
      gameNo: orderNo,
      type: isChangshaGJ ? 23 : 2,
      mtKey: localStorage.getItem('ddmt-i') || '',
    })
    if (window.FuluApp) {
      window.FuluApp!.JSNotifyCppFunc('online_customer_service_vip', result.url, result.jsFile)
    } else {
      newWindow = window.open()
      newWindow && (newWindow.location.href = result.url)
    }
  } catch (error) {
    message.warn((error as any).message)
  }
  // if (!window.FuluApp) {
  //   newWindow = window.open()
  // }
  // IsLogged()
  //   .then((token) => {
  //     return GetContactUrlHS.Execute({
  //       token,
  //       gameNo: orderNo,
  //       type: 2,
  //       mtKey: localStorage.getItem('ddmt-i') || ''
  //     })
  //   })
  //   .then((url) => {
  //     if (window.FuluApp) {
  //       window.FuluApp!.JSNotifyCppFunc('online_customer_service_vip', url)
  //     } else {
  //       ;(newWindow as Window).location.href = url
  //     }
  //   })
  //   .catch((e) => {
  //     console.log('e', e)
  //     ;(newWindow as Window).close()
  //   })
}

/*获取获取当前会话ID*/
export const getPreProcessInfo = () => {
  const channel = GetChannel()
  /*通过 URL 查询字段获取渠道*/
  const Query = new URLSearchParams(window.location.search.substr(1, window.location.search.length))
  GetPreProcessHS.Execute({
    sem: channel,
    searchKey: Query.get('kw') || '',
    actLoadUrl: downUrl(),
    defalutLoadUrl: 'http://download.99box.com/?f=steam9',
  })
}

/*页面最小化*/
export const PageMini = () => {
  window.FuluApp?.JSNotifyCppFunc('min_page')
}

/** 页面最大化切换 */
export const PageMax = () => {
  window.FuluApp?.JSNotifyCppFunc('max_page')
}

/** 切换窗口状态 */
export const changeWindowStatus = (status: 0 | 1 | 2) => {
  console.debug(
    `%c 切换窗口状态 current: ${AppStore.windowStatus} target: ${status}`,
    'font-size:20px;font-weight:bold;color:#7fea2d;',
  )
  /** 版本兼容 */
  if (!CompareWithCurrentVersion([2, 0, 0, 1931])) {
    /** 切换全屏 */
    if (status === 2 || AppStore.windowStatus === 2) {
      window.FuluApp?.JSNotifyCppFunc('set_full_screen')
    } else {
      PageMax()
    }
    return
  }
  window.FuluApp?.JSNotifyCppFunc('set_window_status', status, AppStore.windowStatus)
}

/** 启用/禁用鼠标快捷键 */
export const blockFsKeyboard = (status: number) => {
  window.FuluApp?.JSNotifyCppFunc('block_fs_keyboard', status)
}

/** 页面关闭 */
export const pageClose = () => {
  window.FuluApp?.JSNotifyCppFunc('close_page')
}
/*页面回退*/
export const pageGoBack = () => {
  history.goBack()
}

/*退出应用*/
export const AppExit = () => {
  window.FuluApp?.JSNotifyCppFunc('exit_app')
}
/*卸载应用*/
export const AppUninstall = () => {
  window.FuluApp?.JSNotifyCppFunc('uninstall')
}
/*重装应用*/
export const AppInstall = () => {
  window.FuluApp?.JSNotifyCppFunc('install')
}
/*真实卸载*/
export const AppReallyUninstall = () => {
  window.FuluApp?.JSNotifyCppFunc('really_uninstall')
}
/*启动主客户端*/
export const StartMainClient = () => {
  window.FuluApp?.JSNotifyCppFunc('start_client')
}

/*重置检测步骤*/
const ResetCheckStep = () => {
  AppStore.GameCheckErrorStepMessage = undefined
  AppStore.GameCheckErrorStep = -1
  AppStore.GameCheckStep = 0
}

/*显示绑定手机号弹出框*/
export const showBindMobile = () => {
  AppStore.BindMobileVisible = true
}

/*取消绑定手机*/
export const CancelBindMobile = () => {
  AppStore.BindMobileVisible = false
}

/*重新启动游戏*/
export const ReStartGame = () => {
  if (!AppStore.LastStartGameQuery) {
    return
  }
  if (AppStore.LastStartGameQuery?.[0]?.isActivity) {
    doStartActivityGame.Execute(
      AppStore.LastStartGameQuery[0],
      AppStore.LastStartGameQuery?.[1],
      AppStore.LastStartGameQuery?.[2],
      AppStore.LastStartGameQuery?.[3],
    )
    return
  }
  DoStartGame.Execute(...AppStore.LastStartGameQuery)
}

/*开始启动游戏*/
export const DoStartGame: {
  CheckTimer?: number
  Execute: (Game: StartGameBase, mode: 1 | 2 | 3, ArchiveKey?: string, type?: 0 | 1, jsqArea?: JsqAreaInfo) => void
} = {
  Execute: async (Game: StartGameBase, mode: 1 | 2 | 3, ArchiveKey?: string, type?: 0 | 1, jsqArea?: JsqAreaInfo) => {
    // 该方法已经废弃
  },
}

/*启动游戏*/
export const StartGame = (
  Game: StartGameBase,
  mode: 1 | 2 | 3,
  ArchiveKey?: string,
  type?: 0 | 1,
  jsqArea?: JsqAreaInfo,
) => {
  /*if (guard_status === 1) {
    return false
  }*/
  window.clearTimeout(DoStartGame.CheckTimer)
  if (window.FuluApp) {
    const ChannelConfig = ChannelConfigHS.SuccessResult
    // AppStore.LastStartGameQuery = [Game, mode, ArchiveKey, type, jsqArea]
    if (!(ChannelConfig && ChannelConfig.is_checking === 1)) {
      /*非过白中*/
      if (CompareWithCurrentVersion([1, 0, 0, 560])) {
        window.FuluApp!.JSNotifyCppFunc('get_game_running_status')
      } else {
        DoStartGame.Execute(Game, mode, ArchiveKey, type, jsqArea)
      }
    }
  } else {
    needClient()
  }
}
/** 启动本周开放游戏 */
export const startActivityGame = (Game: GamePlayInfo, mode: 1 | 2 | 3, ArchiveKey?: string, type?: 0 | 1) => {
  window.clearTimeout(doStartActivityGame.CheckTimer)
  window.clearTimeout(DoStartGame.CheckTimer)
  if (window.FuluApp) {
    const ChannelConfig = ChannelConfigHS.SuccessResult
    const gameInfo: GamePlayInfo = {
      ...Game,
      isActivity: true,
    }
    AppStore.LastStartGameQuery = [gameInfo, mode, ArchiveKey, type]
    if (!(ChannelConfig && ChannelConfig.is_checking === 1)) {
      /*非过白中*/
      if (CompareWithCurrentVersion([1, 0, 0, 560])) {
        console.log('456f7456sd4gf564sdg')
        window.FuluApp!.JSNotifyCppFunc('get_game_running_status')
      } else {
        doStartActivityGame.Execute(gameInfo, mode, ArchiveKey, type)
      }
    }
  } else {
    needClient()
  }
}
/**
 * 账号不足提示
 * */
export const GameAccountInsufficient = async (order: GamePlayInfo, isVip: boolean, mode: number) => {
  if (order.type === 7 && mode !== 1 && !isVip) {
    let gameOnlineFull: {
      endtime?: string
      starttime?: string
      content?: string
      title?: string
    } = {}
    const version = await getCMSVersion()
    const data = await DWGetModDataByModIdHttp.Execute({ modId: 'simpleshq_game_full', version })
    if (data?.datas?.[0]?.properties) {
      gameOnlineFull = data.datas[0].properties
    }
    fetch('https://quan.suning.com/getSysTime.do')
      .then(res => res.json())
      //BeijingTime.Execute()
      .then(res => {
        const hasGameOnlineFullFromCms =
          gameOnlineFull.content && gameOnlineFull.title && gameOnlineFull.endtime && gameOnlineFull.starttime
        let isInOffTime
        //const isInOffTime = hasGameOnlineFullFromCms && (moment(res.sysTime2).isAfter(moment(res.sysTime2).hours(Number(gameOnlineFull.starttime)).minute(0).seconds(0).format('YYYY-MM-DD HH:mm:SS')) || moment(res.sysTime2).isBefore(moment(res.sysTime2).hours(Number(gameOnlineFull.endtime)).minute(0).seconds(0).format('YYYY-MM-DD HH:mm:SS')));
        if (hasGameOnlineFullFromCms && Number(gameOnlineFull.endtime) > Number(gameOnlineFull.starttime)) {
          //配置时间在当天
          isInOffTime =
            moment(res.sysTime2).isAfter(
              moment(res.sysTime2)
                .hours(Number(gameOnlineFull.starttime))
                .minute(0)
                .seconds(0)
                .format('YYYY-MM-DD HH:mm:SS'),
            ) &&
            moment(res.sysTime2).isBefore(
              moment(res.sysTime2)
                .hours(Number(gameOnlineFull.endtime))
                .minute(0)
                .seconds(0)
                .format('YYYY-MM-DD HH:mm:SS'),
            )
        } else if (hasGameOnlineFullFromCms && Number(gameOnlineFull.endtime) < Number(gameOnlineFull.starttime)) {
          //配置时间为当天至第二天
          isInOffTime =
            moment(res.sysTime2).isAfter(
              moment(res.sysTime2)
                .hours(Number(gameOnlineFull.starttime))
                .minute(0)
                .seconds(0)
                .format('YYYY-MM-DD HH:mm:SS'),
            ) ||
            moment(res.sysTime2).isBefore(
              moment(res.sysTime2)
                .hours(Number(gameOnlineFull.endtime))
                .minute(0)
                .seconds(0)
                .format('YYYY-MM-DD HH:mm:SS'),
            )
        } else {
          isInOffTime = false
        }
        if (isInOffTime) {
          GameAccountIsInOffTime(gameOnlineFull)
        }
        Modal.confirm({
          title: GameAccountIsFullTitle(),
          content: '若仍较长时间无反应，请联系客服帮您快速解决！',
          className: 'custom Queue',
          onOk: () => {
            OpenCustomerService()
          },
          okText: '联系客服',
          cancelText: '一会儿再来',
        })
      })
  } else {
    const isUpdating = order.to_upgrade === 1
    isLogged().then(token => {
      GamePlayInfoHS.Execute({
        token,
        id: order.id,
      }).then(res => {
        Modal.confirm({
          title: GameAccountIsFullTitle(),
          content: '您可以尝试',
          // className: `custom Queue ${
          //   isUpdating || (!(order.is_vip === 0 && res.is_support_upgrade === 1 && res.is_upgraded !== 1) && !(order.is_vip === 1 && order.is_support_alone === 1)) ? 'notPrimary' : ''
          // }`,
          className: `custom Queue notPrimary`,
          onOk: () => {
            if (order.is_vip === 1 && order.is_support_alone === 1) {
              history.push(`/Game/${order.game_id}`)
            } else {
              GamePlayInfoHS.Execute({
                token,
                id: order.id,
              }).then(({ game_id: gameId, order_no: orderNo }) => {
                AppStore.QueueGameupgrade = {
                  goodsId: gameId,
                  orderNo,
                }
                history.push('/MyOrder')
              })
            }
          },
          onCancel: e => {
            if (isVip) {
              if (!e.triggerCancel) {
                AppStore.QueueVipGameVisible = true
                AppStore.AddGameToQueue = false
                e()
              }
            }
          },
          okText: order.is_vip === 1 && order.is_support_alone === 1 ? '购买独享' : '升级独享',
          cancelText: isVip ? '会员推荐游戏' : '取消',
        })
      })
    })
  }
}

/** 开始启动本周开放游戏 */
export const doStartActivityGame: {
  CheckTimer?: number
  Execute: (Game: GamePlayInfo, mode: 1 | 2 | 3, ArchiveKey?: string, type?: 0 | 1, jsqArea?: JsqAreaInfo) => void
} = {
  Execute: async (Game: GamePlayInfo, mode: 1 | 2 | 3, ArchiveKey?: string, type?: 0 | 1, jsqArea?: JsqAreaInfo) => {
    AppStore.minimizeGameCheckVisible = false
    AppStore.gameUpdatedCompleted = false

    /** 初始化启动步骤 */
    ResetCheckStep()
    /** 清除之前的上号timeout计时器 */
    window.clearTimeout(doStartActivityGame.CheckTimer)
    window.clearTimeout(DoStartGame.CheckTimer)

    const token = await isLogged()

    /** 获取启动游戏相关数据 */
    activityStartGpGameHS
      .Execute({
        activityNo: 'AT5617257222122558248',
        channel: GetChannel(),
        token,
        user_game_id: Game.id,
        gameId: Game.game_id,
        mode,
        mac: AppConfig.PCHardwareInfo?.MAC || '',
      })
      .then(data => {
        /** 更新最近启动 */
        RecentPlayGameHS.Execute({ token })

        /** 预下载游戏不需要弹出检测框 */
        HaiShaJsqStore.JsqRunning = false
        HaiShaJsqStore.gameId = Game.id
        HaiShaJsqStore.areaInfo = jsqArea
        HaiShaJsqStore.jsTime = 0

        AppStore.CheckModalVisible = true
        AppStore.RunningGameName = Game.product_name
        const time = AppStore.StartGameTimeoutConfig.default
        /** 启动超时的定时器 */
        doStartActivityGame.CheckTimer = window.setTimeout(() => {
          Modal.warn({
            title: '启动遇到问题了?',
            content: React.createElement(
              'div',
              null,
              React.createElement('span', null, '1.您可以通过右上角的联系客服，寻求客服帮助'),
              React.createElement('br', null),
              React.createElement('span', null, '2.您可以点击下方的【查看帮助】，查看启动帮助'),
            ),
            okText: '查看帮助',
            className: 'custom AllowClose',
            zIndex: 1006,
            style: { top: 250 },
            onOk: () => {
              AppStore.StartTimeoutConfig &&
                window.FuluApp?.JSNotifyCppFunc('open_url', AppStore.StartTimeoutConfig.newUrl)
            },
          })
          /** 两分钟 或者 根据cms配置时间 自动关闭检测框 */
          HideCheckModal()
        }, time * 1000)

        let checkWifi: 0 | 1 = 1
        let checkMemory: 0 | 1 = 1
        const CheckWifi = localStorage.getItem('WIFINotShow') || sessionStorage.getItem('WIFINotShow')
        const CheckMemory = localStorage.getItem('MemoryNotShow') || sessionStorage.getItem('MemoryNotShow')
        if (CheckWifi) {
          checkWifi = 0
        }
        if (CheckMemory) {
          checkMemory = 0
        }
        console.log(ArchiveKey, type, 'ArchiveKey-type')

        /** 通知云存档使用使用类型 */
        if (CompareWithCurrentVersion([1, 0, 0, 1285])) {
          if (type === 0) {
            AppStore.cloudSaveInstance?.noticeClient('ApplyLocalArchives', {
              order_no: data.order_no,
              archives_name: ArchiveKey || '',
            })
          } else if (type === 1) {
            AppStore.cloudSaveInstance?.noticeClient('ApplyCloudArchives', {
              order_no: data.order_no,
              oss_path: ArchiveKey?.split('#')[0] || '',
              is_check_archives_clash: '0',
            })
          }
        }
        // 开始游戏前 通知云存档
        AppStore.cloudSaveInstance?.noticeClient('BeforeStartGame', {
          order_no: `${data.order_no}`,
          local_archives_size: Number(localStorage.getItem('localArchiveLen') || 0),
          cloud_archives_size: Number(localStorage.getItem('cloudArchiveLen') || 0),
        })

        window.FuluApp!.JSNotifyCppFunc(
          'login_game',
          Number(Game.id),
          Game.appid,
          Game.product_name,
          data.order_no,
          type || 0,
          mode,
          Game.platform,
          ArchiveKey,
          checkWifi,
          checkMemory,
        )
      })
      .catch(res => {
        console.log('已被提取', res)
        //2102为审核中的用户
        if (res.status_code === 2100 || res.status_code === 2101) {
          AppStore.realNameAuthModal = true
          return
        }
        if (res.status_code === 999999) {
          const UserExtendInfo = UserInfoHSTemp.SuccessResult
          const IsVip = UserExtendInfo?.vip !== 0
          if (Game.type !== 7 || mode !== 1) {
            GameAccountInsufficient(Game, IsVip, mode)
            return
          }
          if (
            (QueueStore.queueStatus === 'in' &&
              QueueStore.currentQueueInfo &&
              QueueStore.currentQueueInfo.orderNo !== Game.order_no) ||
            (AppStore.QueueLoading && AppStore.QueueOrderNo !== Game.order_no)
          ) {
            const { product_name: productName = '' } = AppStore.QueueOrder || {}
            DDModal.warn({
              title: '提示',
              content: `您当前《${
                QueueStore.currentQueueInfo?.gameName || productName
              }》正在队列中，如需排队其他游戏请先取消当前排队`,
              okText: '确定',
              className: 'custom',
              zIndex: 1060,
            })
          } else {
            AppStore.QueueVisibile = true
            AppStore.QueueOrder = Game
            AppStore.QueueOrderNo = Game.order_no
            AppStore.QueueVisibile = true
            AppStore.QueueLoading = true
            AppStore.QueueBaseInfo = { gameLibraryImg: Game.list_img }
          }
        } else if (res.status_code === 999991) {
          showBindMobile()
        } else if (res.status_code === 1166) {
          const modal = Modal.confirm({
            title: '提示',
            className: 'custom',
            width: 460,
            centered: true,
            okText: '登录帮助',
            content: `您的独享账号已提取，需要前往第三方平台进行登录上号`,
            onOk: () => {
              modal.destroy()
              console.log(AppStore.aloneExtractYuque, 'AppStore.aloneExtractYuque')
              if (window.FuluApp) {
                window.FuluApp.JSNotifyCppFunc('open_url', AppStore.aloneExtractYuque)
              } else {
                window.open(AppStore.aloneExtractYuque, '_blank')
              }
            },
            cancelText: '我知道了',
          })
        } else {
          message.warning(res.message)
        }
      })
  },
}
/*隐藏游戏存档弹框*/
export const HideGameArchives = () => {
  AppStore.GameArchiveVisible = false
}

/*隐藏新游戏存档弹框*/
export const HideNewGameArchives = () => {
  AppStore.newSaveArchive.newGameArchiveVisible = false
}

/*加载提示线路满时间段和文案*/
// export const getOnlineFull = async () => {
//   const simpleshqGameFull = await useWaitModData('simpleshq_game_full')
//   if (simpleshqGameFull?.[0]) {
//     AppStore.gameOnlineFull = simpleshqGameFull[0]
//   }
// }

/*启动游戏修复工具*/
export const GameRepair = () => {
  if (window.FuluApp) {
    isLogged().then(() => {
      const config = AppStore.GamePlatformConfig[100]
      AppStore.GamePlatformInstallStatus[100] = 2
      config &&
        window.FuluApp!.JSNotifyCppFunc('notify_gameplatform_download_info', 100, config.md5, config.url, config.extend)
    })
  } else {
    needClient()
  }
}

/** 打开gamebuff */
export const openStandAloneGame = () => {
  if (window.FuluApp) {
    window.FuluApp!.JSNotifyCppFunc('open_url', 'https://gamebuff.cn/gj/index.html')
  } else {
    window.open('https://gamebuff.cn/gj/index.html', '_blank')
  }
}

export const formatTimeFixedOffset = (timestamp: number) => {
  return timestamp + (480 - moment().utcOffset()) * 60 * 1000
}

/** 查询并同步其它端游戏状态 */
export const syncUserGameStatus = async () => {
  const { playing, queueing } = await DWgetUserGameStatus.Execute()
  const { writeQueueInfo, quitQueue } = useQueue()
  const { stopCloudGame } = useCloudGameStart()
  /** 排队中 */
  if (queueing && queueing.statusResultObject && QueueStore.queueStatus !== 'in') {
    writeQueueInfo(queueing)
  } else if (!queueing) {
    quitQueue()
  }
  /** 游戏中 移动端只有云游戏模式 */
  if (
    playing &&
    playing.terminal === 'h5' &&
    !['starting', 'running', 'tryRunning'].includes(GameLibraryStore.gameRunStatus)
  ) {
    CloudGameClientStore.gameCloudNo = playing.gameCloudOrderNo
    GameLibraryStore.gameRunStatus = 'running'
    GameLibraryStore.currentTheRunningGameInfo = {
      gameId: playing.goodsId,
      gameLibraryId: playing.gameLibraryId,
      startGameOrderNo: playing.startGameNo || '',
      gameName: playing.gameName,
      gameMode: 'cloud',
      img: '',
      platform: '1',
      allowExit: 'allowExit',
      userGameId: NaN,
      appid: '',
      orderNo: '',
      isSupportArchive: null,
      terminal: playing.terminal,
    }
  } else if (!playing && !CloudGameClientStore.visibleExitConfirmModal) {
    if (GameLibraryStore.currentTheRunningGameInfo?.gameMode === 'cloud') {
      stopCloudGame({ needRequest: false, needArchive: false, reason: '其它端游戏状态变为空闲' })
    } else {
      GameLibraryStore.gameRunStatus !== 'starting' && HideCheckModal()
    }
  }
}

/** 查询每周开放游戏排队状态 */
export const syncLiveBroadcastGameStatus = async () => {
  const token = await isLogged()
  const QueueOrder = localStorage.getItem('queueOrder')
  const QueueGame = localStorage.getItem('queueGame')
  const queueGameAreainfo = localStorage.getItem('queueGameAreainfo')
  if (!QueueOrder || !QueueGame) {
    return
  }
  const queryQueueInfo = await QueryQueueHS.Execute({ token, order_no: QueueOrder })
  if (queryQueueInfo.status !== 1) {
    return
  }
  doStartActivityGame.Execute(
    JSON.parse(QueueGame),
    1,
    undefined,
    undefined,
    queueGameAreainfo ? JSON.parse(queueGameAreainfo) : undefined,
  )
}

/** 查询用户游戏状态
 *  status: 空闲：free, 排队中：queuing, 游戏中：playing
 */
export const loadUserGameStatus = () => {
  /*等待用户信息被加载*/
  const waitUserLogin = reaction(
    () => UserInfoHS.SuccessResult,
    async UserExtendInfo => {
      syncUserGameStatus()
      syncLiveBroadcastGameStatus()
      waitUserLogin()
    },
  )
}

export const CalcGamePrice = (Game: BaseGameList): number => {
  /*无论用户是不是会员 都展示会员价*/
  const { share_offline: shareOffline, share_online: shareOnline, alone } = Game
  let Price //合玩价格
  if (shareOffline) {
    /*支持离线*/
    const { price, vip_price: vipPrice } = shareOffline
    if (vipPrice === 0) {
      /*离线会员免费*/
      if (Price) {
        if (price < Price) {
          /*离线价更低*/
          Price = price //离线价
        }
      } else {
        Price = price //离线价
      }
    } else if (Price) {
      if (vipPrice < Price) {
        /*离线会员价更低*/
        Price = vipPrice //离线的会员价
      }
    } else {
      Price = vipPrice //离线的会员价
    }
  }
  if (shareOnline) {
    /*支持共享*/
    const { year_vip_price: yearVipPrice, vip_price: vipPrice, price } = shareOnline
    if (yearVipPrice !== undefined && yearVipPrice !== 0) {
      /*如果年会员有优惠 且年会员价格不是免费*/
      if (Price) {
        if (yearVipPrice < Price) {
          /*年会员优惠价格更低 */
          Price = yearVipPrice
        }
      } else {
        Price = yearVipPrice
      }
    }
    if (vipPrice !== 0) {
      /*如果会员不免费*/
      if (Price) {
        if (vipPrice < Price) {
          Price = vipPrice
        }
      } else {
        Price = vipPrice
      }
    }
    if (Price) {
      if (price < Price) {
        Price = price
      }
    } else {
      Price = price
    }
  }
  if (alone) {
    /*如果支持独享*/
    const { vip_price: vipPrice, price } = alone
    if (Price) {
      if (vipPrice !== 0 && vipPrice < Price) {
        /*非会员免费 且价格更低*/
        Price = vipPrice
      }
    } else {
      Price = vipPrice
    }
    if (Price) {
      if (price < Price) {
        /*价格更低*/
        Price = price
      }
    } else {
      Price = price
    }
  }
  return Price || 0
}
export const formatJavaPayMethod = (payWay: TPayWay) => {
  switch (payWay) {
    case 'alipay':
      return 'alipay_scan'
    case 'wechat':
      return 'wechat_scan'
    case 'qq_wallet':
      return 'qq_scan'
  }
  return 'alipay_scan'
}
/**
 * @deprecated 保证金流程请使用showNeedDeposit
 * 缴纳保证金
 */
export const ChargeDeposit: {
  StopPolling?: Function
  Execute: (
    payType: TPayWay,
    gameId: number,
    chargeDepositOrderCancel: Function,
    showPayChargeDeposit: () => void,
  ) => void
} = {
  Execute: (payType: TPayWay, gameId: number, chargeDepositOrderCancel: Function, showPayChargeDeposit: () => void) => {
    ChargeDeposit.StopPolling?.()
    isLogged().then(async token => {
      const formatPayMethod = formatJavaPayMethod(payType)
      try {
        const thirdId = get3rdIdFromSetupName()
        const createJavaOrderHttpResult = await CreateOrderJavaHttpHS.Execute({
          gameId,
          useBalance: 0,
          balanceType: undefined,
          orderType: 30,
          payMode: formatPayMethod,
          channel: GetChannel(),
          ...(thirdId ? { tags: [{ type: 'reportThirdTagId', value: thirdId, source: null }] } : {}),
        })

        const success = (isWechat: boolean) => {
          checkChargeDepositTips(isWechat)
          chargeDepositOrderCancel()
          ForbidInfoHS.Execute({ page: 'start', channel: GetChannel() }) // 更新禁封状态
        }

        if (createJavaOrderHttpResult.hasThridPay === 0) {
          success(false)
          return
        }

        const orderNo = createJavaOrderHttpResult.orderNo
        await createPayHS.Execute({
          balanceNo: createJavaOrderHttpResult.balanceNo,
          payMode: formatPayMethod,
        })

        showPayChargeDeposit()

        ChargeDeposit.StopPolling = checkDepositeOrderPayStatus(
          { order_no: orderNo, order_type: 'deposit' },
          () => {
            success(payType === 'wechat') //更新禁封状态
          },
          () => {
            message.warning('支付订单超时!')
            chargeDepositOrderCancel()
          },
        )
      } catch (error) {
        message.warning((error as any).message)
      }
    })
  },
}
/*获取禁售游戏配置*/
/*export const NotSaleGameConfig = () => {
  DWGetModDataByModIdHttp.Execute({ modId: 'simpleshq_share_hide' }).then((data: ModData<{ gameid: string; mode: 2 | 3 }>) => {
    const NotSaleGame: { [key in 3 | 2]?: number[] } = {}
    data.datas.forEach(d => {
      NotSaleGame[d.properties.mode] = d.properties.gameid.split(',').map(d => Number(d))
    })
    AppStore.NotSaleGameConfig = NotSaleGame
  })
}*/

export const loadCMSConfig = () => {
  const modIds = [
    'simple_tools_config',
    'simpleshq_buy_mode',
    'simpleshq_tools_platform',
    'simpleshq_buy_title',
    'simpleshq_sale_protocol',
    'simpleshq_steam_uplay',
    'simple_refound_note',
    'simpleshq_game_cundang',
    'simpleshq_steam_message',
    'simpleshq_speed_banner',
    // 'simpleclient_cloud_info_config',
    'simpleshq_start_timeout',
    'simpleshq_set_timeout',
    'simpleshq_home_verify',
    'simpleshq_notView_wechat',
    'simpleclient_floatImg_config',
    'simpleclient_pay_tips',
    'simpleclient_cdk_extracturl',
    'simpleclient_new_active_channel',
    'simpleshq_binding_cloud_time',
    'gj_spike_special_banner',
    'simpleclient_floatIcon_config',
    'simpleclient_BBS_View',
    'simpleclient_c5_channel',
    'vip_activity_channel',
    'simpleclient_fastRefund_config',
    'pubg_banner_config',
    'client_upgrade_config',
    'simpleclient_buy_promise_config',
    'simpleclient_anchor_config',
    'simpleclient_anchor_info',
    'simpleclient_accounttype_description',
    'simpleclient_accountDescription_config',
    'simpleclient_start_help_config',
    'simpleclient_global_qq_config',
    'simpleshq_cloud_mobileqrcode',
    'guansha_active12_code',
    'common_help_config',
    'simpleshq_coupon_tag_config',
    'simpleshq_auth_switch',
    'simpleshq_alone_switch',
    'gjsj_spike_special_tag',
    'simpleshq_pagegame_config',
    'simpleclient_home_customer_switch',
    'simpleclient_search_hostlist',
    'simpleclient_balance_limit_tips',
    // 分享赚钱页面(/share-makemoney)介绍配置
    'sharemakemoney_help_config',
    // 'simpleshq_login_cfg_v2', // 登录页在用，其他地方不需要

    /** @TODO ---start--- 这个cms配置等use-cms库加强 datasId之后迁移 */

    // 'simpleshq_extractinfo_config',
    // 'simpleshq_notes',

    /** @TODO ---end--- */

    /** 已修改的 */
    'simpleclient_pagegame_rankconfig',
    'simpleclient_pagegame_recommend',
    'simpleclient_header_tabswitch',
    'simpleclient_pagegame_banner',
    'simple_auto_download_platform',
    'simpleshq_get_account',
    'simple_get_account',
    'simple_account _confirm',
    'simpleshq_order_cdknotes',
    'simpleshq_new_home_banner',
    'simpleshq_home_recommend',
    'simpleshq_cdk_hotkey',
    'simpleshq_cdk_salesRanking',
    'simpleclient_margin_game',
    'simpleshq_home_package',
    'simple_product_description_config',
    'simpleclient_realname_auth',
    'simpleclient_myGame_banner',
    'simpleshq_refund_confirm1',
    'haisha_client_qq_config',
    'simpleshq_game_maintain',
    'simpleshq_special_game',
    'simple_active1_gameConfig',
    'simpleclient_new_active_config1',
    'simpleclient_cloud_info_tips_config',
    'simpleshq_new_index_banner',
    'simpleshq_web_footbaner',
    'simpleshq_activity_51',
    'simpleclient_101_rules',
    'simpleclient_anchor_img',
    'guansha_active_rules',
    'simple_client_cloud_thematic_config',
    'simpleclient_halloween_rules',
    'simpleclient_815_rules',
    'simpleshq_scan_code_receive',
    'simpleshq_pubg13_config',
    'simpleclient_duanwu_rule',
    'simpleclient_buypage_pubg',
    'guansha_community_config',
    'help_img_config',
    'simpleshq_after_sale_config',
    'simpleshq_serive_contact',
    'simpleshq_gog_tel',
    'vip_service_tips',
    'simpleclient_speed_cfg',
    'simpleclient_replace_game_config',
    'simpleshq_order_upgrade',
    'simpleshq_oder_refund',
    'simpleshq_order_account',
    'simpleshq_Notification_config',
    'simpleclient_cdk_help_url',
    'simpleclient_ancho_channel_config',
    'simpleclient_active520_time',
    'simpleclient_PUBG_tab',
    'simpleshq_header_search',
    'simpleshq_zycm_listname',
    'guansha_community_config',
    'simpleclient_vip_question',
    'simple_vip_center_bg_img',
    'simpleshq_vip_game_recommend',
    'simpleclient_vip_power_config',
    'other_service_tips_config',
    'simpleshq_modifier_goods',
    'success_community_config',
    'simpleshq_start_contact',
    'simpleshq_classified_recommend_config',
    'simpleshqclient_new_detail_game',
    'simpleclient_package_banner',
    'simpleclient_navigation_config',
    'simpleshq_home_question',
    'simpleclient_after_service_config',
    'simpleclient_cloudGame_guide',
    'simpleclient_cdk_detail_config',
    'global_paymethod_config',
    'simpleclient_detail4_tab_config',
    'simpleclient_undercarriage_switch',
    'order_refund_item_reason',
    'simpleclient_extract games_note',
    'simpleshqclient_start_tab_config',
    'common_baw_config',
    'csgo_unpack_config',
    //管家通用配置，单个字段的配置可以放这里
    'simpleshq_common_config',
    'simple_christmas_config',
    'simpleclient_startgame_kefu_switch',
    'simpleclient_success_customer_modal',
    'simpleclient_startGame_customer_pop',
    'simpleclient_vip_coupon_modal',
    'simpleclient_blizzard_recharge',
    'simpleclient_start_tab_ad',
    'simpleshq_csgo_url',
    'simpleshq_search_ad_global_empty',
    'simpleshq_search_ad_list_empty',
    'simpleshq_search_ad_list',
    'simpleshq_filter_tips',
    'simpleshq_ocpc',
    'simpleshqclient_game_detail_5_order',
    'simpleclient_vip_style_config',
    'simpleclient_unite_vip',
    'simpleclient_mod_serve_id',
    'simpleclient_vip_entry_banner',
    'simpleclient_vip_update_modal_config',
    'simpleclient_start_recommend_ad',
    'simpleclient_start_recommend_config',
    'simpleclient_speed_test',
    'simpleclient_mod_service_style',
    'simpleclient_23915_activity_config',
    'simpleclient_notuse_discounts_config',
    'simpleclient_douyin_channel_config',
    'simpleshq_tags_tips',
    'simpleclient_recommend_week',
    'simpleclient_recommend_bg',
    'simpleshq_notice_tab_config',
    'simpleshq_mod_link',
    'simpleshq_viewpayment_by_usertag',
    // 已移除
    // 'simple_vipact_tip',
  ]
  AppStore.CSGOIsLoadingEnd = false

  const ENV_MAPPING = {
    dev: 'dev',
    test: 'test',
    pre: 'prev',
    prod: 'prod',
  }
  initPollModIds({
    env: ENV_MAPPING[process.env.BUILD_TYPE] as any,
    //长沙管家自定义cms接口的host
    host: (isChangshaGJ && API_URL.ORIGIN) || undefined,
    modIds,
    /** 每60分钟更新一次cms配置 */
    speed: 1000 * 60 * 60,
    callback: count => {
      if (count === 1) {
        modIds.forEach(modId => {
          /** 为了兼容以前的代码， 这里封装成这个数据结果 */
          const d = {
            modId,
            datas: ModDatas.current[modId],
          }
          switch (modId) {
            case 'simple_tools_config':
              loadToolsConfig(d)
              break
            case 'simpleclient_notuse_discounts_config':
              loadNotUseDiscountsConfig(d)
              break
            case 'simpleclient_23915_activity_config':
              load23915ActivityConfig(d)
              break
            case 'simpleclient_cdk_extracturl':
              loadCDKExtractUrl(d)
              break
            case 'simpleclient_floatImg_config':
              loadFloatImgConfig(d)
              break
            case 'simpleshq_viewpayment_by_usertag':
              loadViewpaymentByUserTag(d)
              break
            case 'simpleclient_new_active_channel':
              loadActivityChannel(d)
              break
            case 'simpleshq_buy_mode':
              LoadBuyModeConfig(d)
              break
            case 'simpleshq_tools_platform':
              LoadGamePlatformConfig(d)
              break
            case 'simpleshq_buy_title':
              LoadBuyTitleConfig(d)
              break
            case 'simpleclient_speed_test':
              LoadSpeedTestConfig(d)
              break
            case 'simpleshq_sale_protocol':
              LoadAgreementConfig(d)
              break
            case 'simpleshq_steam_uplay':
              SteamVerUplayGameTips(d)
              break
            case 'simple_refound_note':
              RefundPromiseConfig(d)
              break
            case 'simpleshq_game_cundang':
              NotArchiveGamesConfig(d)
              break
            case 'simpleshq_steam_message':
              LoadStartPlatformConfig(d)
              break
            case 'simpleshq_speed_banner':
              LoadJsqConfig(d)
              break
            // case 'simpleclient_cloud_info_config':
            //   loadCloudTimeConfig(d)
            //   break
            case 'simpleshq_start_timeout':
              LoadStartTimeOutConfig(d)
              break
            case 'simpleshq_set_timeout':
              LoadStartGameTimeOutConfig(d)
              break
            case 'simpleshq_home_verify':
              LoadNotShowVerify(d)
              break
            case 'simpleshq_notView_wechat':
              loadNotViewWechat(d)
              break
            case 'simpleclient_pay_tips':
              loadPayTips(d)
              break
            case 'simpleshq_binding_cloud_time':
              loadBindingCloudGameTime(d)
              break
            case 'gj_spike_special_banner':
              loadSpikeSpecialBanner(d)
              break
            case 'common_help_config':
              loadCommonHelpConfig(d)
              break
            case 'simpleclient_accountDescription_config':
              loadAccountDescriptionConfig(d)
              break
            case 'simpleclient_accounttype_description':
              loadAccountTypeDescription(d)
              break
            case 'client_upgrade_config':
              loadUpgradeConfig(d)
              break
            case 'simpleclient_floatIcon_config':
              loadFloatIconConfig(d)
              break
            case 'simpleclient_c5_channel':
              loadC5Blacklist(d)
              break
            case 'simpleclient_BBS_View':
              loadBBSViewConfig(d)
              break
            case 'vip_activity_channel':
              loadVipBlacklist(d)
              break
            case 'simpleclient_fastRefund_config':
              LoadFastRefundConfig(d)
              break
            case 'pubg_banner_config':
              loadPUBGBannerConfig(d)
              break
            case 'simpleclient_buy_promise_config':
              loadBuyPromiseConfig(d)
              break
            case 'simpleclient_anchor_config':
              loadAnchorConfig(d)
              break
            case 'simpleclient_start_help_config':
              loadStartHelpConfig(d)
              break
            case 'simpleclient_global_qq_config':
              loadQQConfig(d)
              break
            case 'simpleshq_cloud_mobileqrcode':
              loadMobileDownload(d)
              break
            case 'guansha_active12_code':
              loadActive12Code(d)
              break
            case 'simpleshq_coupon_tag_config':
              loadCouponTagConfig(d)
              break
            case 'simpleshq_auth_switch':
              loadAuthSwitchConfig(d)
              break
            case 'simpleshq_alone_switch':
              loadAloneSwitch(d)
              break
            case 'simpleclient_home_customer_switch':
              loadCustomerSwitch(d)
              break
            case 'guansha_community_config':
              loadCommunityConfig(d)
              break
            case 'simpleshq_modifier_goods':
              loadModifierDownLoadConfig(d)
              break
            case 'simpleshqclient_new_detail_game':
              loadNewGameDetailConfig(d)
              break
            case 'simpleclient_navigation_config':
              loadNewNavigationConfig(d)
              break
            case 'simpleclient_cloudGame_guide':
              loadCloudGameGuideConfig(d)
              break
            case 'simpleclient_cdk_detail_config':
              loadCDKDetailHelpConfig(d)
              break
            case 'simpleclient_undercarriage_switch':
              loadUndercarriageSwitch(d)
              break
            case 'simpleshqclient_start_tab_config':
              loadStartGameTabOrdercConfig(d)
              break
            case 'common_baw_config':
              loadCommonBAWConfig(d)
              break
            case 'csgo_unpack_config':
              loadCsgoUnpackConfig(d)
              break
            case 'simpleshq_common_config':
              loadCommonConfig(d)
              break
            case 'simpleclient_startgame_kefu_switch':
              loadStartGameServiceConfig(d)
              break
            case 'simpleclient_startGame_customer_pop':
              loadStartGameCustomerPop(d)
              break
            case 'simpleclient_vip_coupon_modal':
              loadVipCouponModalConfig(d)
              break
            case 'simpleclient_blizzard_recharge':
              loadBlizzardRechargeConfig(d)
              break
            case 'simpleclient_start_tab_ad':
              loadStartGameTabAdConfig(d)
              break
            case 'simpleshq_csgo_url':
              loadCSGOCommunityServices(d)
              break
            case 'simpleshq_search_ad_global_empty':
              loadSearchAdGlobalEmptyConfig(d)
              break
            case 'simpleshq_search_ad_list_empty':
              loadSearchAdListEmptyConfig(d)
              break
            case 'simpleshq_search_ad_list':
              loadSearchAdListConfig(d)
              break
            case 'simpleshqclient_game_detail_5_order':
              loadGameDetail5Order(d)
              break
            case 'simpleclient_mod_serve_id':
              loadModServeId(d)
              break
            case 'simpleclient_vip_entry_banner':
              loadVipEntryBannerConfig(d)
              break
            case 'simpleclient_start_recommend_config':
              loadStartRecommendConfig(d)
              break
            case 'simpleclient_douyin_channel_config':
              loadDouyinChannelConfig(d)
              break
            default:
              break
          }
        })
      }
    },
  })
  DWCMSVersionHttp.Execute().then(res => {
    const version = `${res}_${window.location.host}`
    AppStore.CMSVersion = version
  })
}
const loadDouyinChannelConfig = async (data: ModData<{ channel: string }>) => {
  const info = data?.datas?.map(d => d.properties)?.[0]
  localStorage.setItem('douyinChannelConfig', info?.channel)
  AppStore.douyinChannelConfig = info?.channel?.split(',')
}
const loadStartRecommendConfig = async (data: ModData<{ recommend1: string }>) => {
  const info = data?.datas?.map(d => d.properties)?.[0]
  AppStore.startRecommendConfig = info
}
const loadVipEntryBannerConfig = async (data: ModData<{ userInfoBanner: string; storeBanner: string }>) => {
  const info = data?.datas?.map(d => d.properties)?.[0]
  AppStore.vipEntryBannerConfig = info
}
// mod付费服务id
const loadModServeId = async (data: ModData<{ goodsId: string }>) => {
  const info = data?.datas?.map(d => d.properties)?.[0]
  AppStore.modServeId = info?.goodsId ? Number(info?.goodsId) : undefined
}
// 详情页模板5排列顺序
const loadGameDetail5Order = async (data: ModData<{ open: string }>) => {
  const info = data?.datas?.map(d => d.properties)?.[0]
  AppStore.gameDetailRelatedProductSwitch = info.open === '1'
}
const loadVipCouponModalConfig = async (data: ModData<{ bg: string }>) => {
  const info = data?.datas?.map(d => d.properties)?.[0]
  AppStore.vipCouponModalConfig = info
}

const loadBlizzardRechargeConfig = async (data: ModData<{ gameLibraryIds: string; goodsLink: string }>) => {
  const info = data?.datas?.map(d => d.properties)
  const commonConfig = info?.pop?.()
  const gameLibraryIds = commonConfig?.gameLibraryIds?.split(',') ?? []
  AppStore.blizzardRechargeConfig = {
    gameLibraryIds,
    goodsList: info,
    goodsLink: commonConfig?.goodsLink,
  }
}

const loadStartGameCustomerPop = async (data: ModData<{ codeImg: string; text: string }>) => {
  const info = data?.datas?.map(d => d.properties)?.[0]
  AppStore.startGameCustomerPop = info
}

/** 上号前实名认证成功后是否需要弹出客服弹窗 */
const loadStartGameServiceConfig = async (data: ModData<{ switch: string }>) => {
  const info = data?.datas?.map(d => d.properties)?.[0]
  AppStore.startGameServiceSwitch = info.switch === '1'
}
/** 启动页菜单tab展示顺序 */
const loadStartGameTabOrdercConfig = async (data: ModData<TStartGameTabOrdercConfig & { [key: string]: string }>) => {
  const version = await getCMSVersion()
  const res = await DWGetModDataByModIdHttp.Execute({ modId: 'simpleclient_start_tab_ad', version })
  const allAdList = (res.datas?.map(d => d?.properties) as TadList[])?.sort((a, b) => a.sort - b.sort)

  const info = data?.datas?.map(d => d.properties)
  info?.forEach(d => {
    const gameLibraryIds = d?.gameLibraryId?.split(',') || []

    gameLibraryIds.forEach(gameLibraryId => {
      const currentGameAdList: TadList[] = []
      allAdList.forEach(item => {
        if (item?.gameLibraryId?.includes(gameLibraryId)) {
          currentGameAdList.push(item)
        }
      })

      AppStore.startGameTabOrdercConfig[gameLibraryId] = {
        ...d,
        adList: currentGameAdList,
      }
    })
  })
}

/** 启动页菜单tab广告位展示顺序 */
const loadStartGameTabAdConfig = async (data: ModData<TadList>) => {
  const allAdList = (data.datas?.map(d => d?.properties) as TadList[])?.sort((a, b) => a.sort - b.sort)
  allAdList?.forEach(d => {
    const gameLibraryIds = d?.gameLibraryId?.split(',') || []
    gameLibraryIds.forEach(gameLibraryId => {
      if (AppStore.startGameTabAdList[gameLibraryId]) {
        AppStore.startGameTabAdList[gameLibraryId] = [...AppStore.startGameTabAdList[gameLibraryId], d]
      } else {
        AppStore.startGameTabAdList[gameLibraryId] = [d]
      }
    })
  })
}

/** 加载通用配置 */
const loadCommonConfig = async (data: ModData<{ [p: string]: string }>) => {
  const info = data?.datas?.map(d => d.properties)?.[0]
  AppStore.commonConfig = info
}
/** 加载社区服配置 */
const loadCSGOCommunityServices = async (data: ModData<{ url: string; gameLibraryId: string }>) => {
  AppStore.CSGOCommunityServices = data?.datas?.map(d => d.properties)
}

/** 加载搜索-全局空状态广告配置 */
const loadSearchAdGlobalEmptyConfig = async (data: ModData<any>) => {
  AppStore.searchAdGlobalEmptyConfig = data?.datas?.map(d => d.properties)
}

/** 加载搜索-列表空状态广告配置 */
const loadSearchAdListEmptyConfig = async (data: ModData<any>) => {
  AppStore.searchAdListEmptyConfig = data?.datas?.map(d => d.properties)
}

/** 加载搜索-列表有结果广告配置 */
const loadSearchAdListConfig = async (data: ModData<any>) => {
  AppStore.searchAdListConfig = data?.datas?.map(d => d.properties)
}

/** 加载csgo开箱的配置 */
const loadCsgoUnpackConfig = async (data: ModData<{ isView: string }>) => {
  const info = data?.datas?.map(d => d.properties)?.[0]
  AppStore.csgoUnpackIsView = info?.isView === '1'
}
/** 页面是否展示为黑白颜色 */
const loadCommonBAWConfig = async (data: ModData<{ box: string }>) => {
  const info = data?.datas?.map(d => d.properties)?.[0]
  AppStore.isShowBAW = info?.box === '1'
}
/** 下架游戏库是否展示开关 */
const loadUndercarriageSwitch = async (data: ModData<{ switch: string }>) => {
  const info = data?.datas?.map(d => d.properties)?.[0]
  AppStore.undercarriageSwitch = info?.switch === '1'
}
/** cdk详情页商品帮助通用配置 */
const loadCDKDetailHelpConfig = (data: ModData<{ config: string }>) => {
  const info = data?.datas?.map(d => d.properties)?.[0]
  AppStore.CDKDetailHelpConfig = info.config
}
/** 云游戏排队引导配置 */
const loadCloudGameGuideConfig = (data: ModData<{ startTime: string; endTime: string; text: string }>) => {
  const info = data?.datas?.map(d => d.properties)?.[0]
  AppStore.cloudGameGuideConfig = info
}
/** 是否开启新版二级导航 */
const loadNewNavigationConfig = (data: ModData<{ open: string }>) => {
  AppStore.newNavigationFlag = data?.datas?.map(d => d.properties)?.[0].open === '1'
}
/** 加载新版详情页游戏配置 */
const loadNewGameDetailConfig = (
  data: ModData<{ gameLibraryId1: string; gameLibraryId2: string; gameLibraryId5: string }>,
) => {
  const info = data?.datas?.map(d => d.properties)?.[0]
  // pubg模板
  localStorage.setItem('newGameDetailId1', info?.gameLibraryId1)
  // 模板5
  localStorage.setItem('newGameDetailId5', info?.gameLibraryId5)
}
/** 加载修改器渠道包配置 */
const loadModifierDownLoadConfig = (data: ModData<TModifierDownLoadConfig>) => {
  AppStore.modifierDownLoadConfig = data?.datas?.map(d => d.properties)
}

/** 加载社群消息配置 */
const loadCommunityConfig = (
  data: ModData<{ title: string; img: string; desc: string; type: '1' | '2' | '3' | '4' | '5' | '6' }>,
) => {
  //长沙管家屏蔽社群入口
  if (isChangshaGJ) {
    return
  }
  const getDesc = (descStr: string) => {
    const matchReg = /\{([^}]*)\}/gi
    return descStr.match(matchReg)?.map(x => x.replace(matchReg, '$1')) || []
  }
  data?.datas?.forEach(d => {
    const data = d.properties
    const config = { ...data, desc: getDesc(data.desc) }
    switch (data.type) {
      case '1':
        AppStore.buySuccessCommunity = config
        break
      case '2':
        AppStore.refundCommunity = config
        break
      case '3':
        AppStore.startCommnunity = config
        break
      case '4':
        AppStore.rechargeCommnunity = config
        break
      case '5':
        AppStore.welfareCommnunity = config
        break
      case '6':
        AppStore.gameAssistant = data
        break
      default:
    }
  })
}

const loadCustomerSwitch = (data: ModData<{ isToHelp: string; headerIsToHelp: string }>) => {
  AppStore.customerSwitch = (data.datas?.[0]?.properties?.isToHelp || '1') as '0' | '1'
  AppStore.headerCustomerSwitch = (data.datas?.[0]?.properties?.headerIsToHelp || '1') as '0' | '1'
}

/** 加载语雀帮助（针对独享被提取后，启动游戏时的提示弹框） */
const loadAloneExtractYuqueConfig = (data: ModData<{ url: string }>) => {
  AppStore.aloneExtractYuque = data.datas?.[0].properties.url
}
const loadSpikeSpecialBanner = (data: ModData<TSearchConfig>) => {
  const temp = data?.datas?.map(d => d.properties).sort((a, b) => a.sort - b.sort)
  AppStore.searchConfig = temp
}
const loadAloneSwitch = (data: ModData<{ close: string; gameId: string }>) => {
  const temp = data?.datas?.[0]?.properties
  AppStore.closealoneSwitchConfig = temp?.close === '1'
  AppStore.closeAloneSwitchwhiteList = temp?.gameId?.split(',') || []
}
/** 加载实名认证弹框开关配置 */
const loadAuthSwitchConfig = (data: ModData<{ login: string; buy: string; start: string }>) => {
  const temp = data?.datas?.[0]?.properties
  AppStore.authSwitchConfig = {
    loginFlag: temp?.login === '1',
    buyFlag: temp?.buy === '1',
    startFlag: temp?.start === '1',
  }
}
const loadCouponTagConfig = (data: ModData<{ open: string }>) => {
  AppStore.couponTagVisible = data?.datas?.[0]?.properties?.open === '1'
}
const loadCommonHelpConfig = (data: ModData<Tools.KeyValueProp<string>>) => {
  const config = data?.datas?.[0]?.properties?.['管鲨客户端'] === '1'
  if (config) {
    AppStore.standbyHelp = true
  }
}

/** 加载双12群 */
const loadActive12Code = (data: ModData<{ img: string }>) => {
  AppStore.active12Code = getOEMCMSProperty(data.datas?.[0].properties, 'img')
}

/** 加载全局的移动端下载二维码 */
const loadMobileDownload = (data: ModData<{ img: string }>) => {
  AppStore.mobileDownload = data.datas?.[0].properties.img
}
/** 加载全局QQ群配置信息 */
const loadQQConfig = (data: ModData<{ GameQQlink: string; GameQQnumber: string; GameQQnumberpic: string }>) => {
  AppStore.QQConfig = data.datas?.[0].properties
}

/** 加载上号平台帮助 */
const loadStartHelpConfig = (data: ModData<TStartHelpConfig>) => {
  AppStore.startHelpConfig = data.datas?.[0].properties
  console.log(AppStore.startHelpConfig, '加载上号平台帮助')
}
/** 载入主播相关配置 qq群 规则 主播推荐 */
const loadAnchorConfig = (
  data: ModData<{ ids?: string; qq?: string; rules?: string; discount?: string; gamesNum?: string }>,
) => {
  AppStore.anchorConfig = data.datas?.[0].properties
}
/** 加载下单页承诺文案 */
const loadBuyPromiseConfig = (
  data: ModData<{ notSupportTypes: string; img: string; title: string; description: string }>,
) => {
  AppStore.buyPromiseConfig = data.datas?.map(d => {
    return {
      ...d.properties,
      notSupportTypes: d.properties.notSupportTypes ? d.properties.notSupportTypes.split(',') : [],
    }
  })
}

/** 加载 */
const loadPUBGBannerConfig = (
  data: ModData<{ imgUrl: string; targetUrl: string; viewIds: string; newUrl: string }>,
) => {
  AppStore.PUBGBannerConfig = data.datas?.[0].properties
}

/** 加载需要显示极速退款的游戏 */
const LoadFastRefundConfig = (data: ModData<{ gameId: string }>) => {
  AppStore.viewFastRefundIds = data.datas.map(d => d.properties.gameId)
}

/** 加载VIP活动黑名单 */
const loadVipBlacklist = (data: ModData<{ channel: string }>) => {
  if (data && data.datas && data.datas[0] && data.datas[0].properties?.channel) {
    const channelBlacklist = data.datas[0].properties?.channel.split(',')
    const channel = GetChannel()
    AppStore.vipActivityChannel = !channelBlacklist.includes(channel)
  }
}

/** 加载c5渠道黑名单 */
const loadC5Blacklist = (data: ModData<{ channel: string }>) => {
  if (data && data.datas && data.datas[0] && data.datas[0].properties?.channel) {
    const channelBlacklist = data.datas[0].properties?.channel.split(',')
    const channel = GetChannel()
    AppStore.isShowC5Tab = !channelBlacklist.includes(channel)
    AppStore.CSGOIsLoadingEnd = true
  }
}

/** 加载需要展示论坛的游戏 */
const loadBBSViewConfig = (data: ModData<{ ids: string }>) => {
  if (data && data.datas && data.datas[0]) {
    AppStore.viewBBSIds = data.datas[0].properties.ids.split(',')
  }
}

/** 加载 购买页-共享独享区别文案 */
const loadAccountDescriptionConfig = (data: ModData<TAccountDescriptionConfig>) => {
  if (data) {
    AppStore.accountDescriptionConfig = data.datas
      .sort((a, b) => {
        return Number(a.properties.sort || 999) - Number(b.properties.sort || 999)
      })
      .map(d => d.properties)
  }
}

/** 加载 购买页-账号类型的描述文案 */
export const loadAccountTypeDescription = (data: ModData<TAccountTypeDescription>) => {
  if (data?.datas?.[0]?.properties) {
    AppStore.accountTypeDescription = data.datas[0].properties
  }
}

/** 加载订单升级配置 */
const loadUpgradeConfig = (data: ModData<{ textUpgradeCDK: string; textUpgradeAccount: string }>) => {
  if (data && data.datas && data.datas[0]) {
    AppStore.orderUpgradeText = data.datas[0].properties
  }
}

/** 加载右下角浮动的活动入口配置 */
const loadFloatIconConfig = (data: ModData<{ img: string; newUrl: string; jump: 'in' | 'out' }>) => {
  if (data && data.datas && data.datas[0]) {
    AppStore.floatIconConfig = {
      ...data.datas[0].properties,
      path: data.datas[0].properties.newUrl,
    }
  }
}

/** 加载cdk兑换教程地址 */
const loadCDKExtractUrl = (data: ModData<{ newUrl: string }>) => {
  data.datas.forEach(d => {
    AppStore.cdkExtractUrl = d.properties.newUrl
  })
}

/** 不可以使用优惠的goodsid */
const loadNotUseDiscountsConfig = (data: ModData<{ ids?: string }>) => {
  if (data.datas?.[0]) {
    AppStore.notUseDiscountsIds = data.datas[0].properties?.ids?.split(',') || []
  }
}

/** 辅助工具配置 */
const loadToolsConfig = (data: ModData<TToolsItem>) => {
  AppStore.toolsConfigs = data?.datas?.map(d => d.properties) || []
}

/** 加载23-09-15活动配置 */
const load23915ActivityConfig = (
  data: ModData<{
    switch?: '0' | '1'
    cdkids?: string
    vipid?: string
    vipPrice?: string
    key?: string
    mode?: string
    text1?: string
    text2?: string
    text3?: string
    hidebtn?: string
    isDialog?: string
    isPermanent?: string
    blackList?: string
  }>,
) => {
  data.datas.forEach(d => {
    if (d.properties.switch === '1' && d.properties.key) {
      AppStore['activity-23-9-15'].configs.push({
        key: d.properties.key,
        cdkids: d.properties.cdkids?.split(',') || [],
        vipid: d.properties?.vipid || '',
        vipPrice: d.properties?.vipPrice || '',
        mode: d.properties.mode === '2' ? '2' : '1',
        text1: d.properties.text1 || '',
        text2: d.properties.text2 || '',
        text3: d.properties.text3 || '',
        hideBtn: d.properties.hidebtn === '1',
        isDialog: d.properties.isDialog === '1',
        isPermanent: d.properties.isPermanent === '1',
        isBlack: userInfo => {
          if (!userInfo) {
            /** 没有登录时一定显示 */
            return false
          }
          const blackList = d.properties.blackList ? d.properties.blackList.split(',') : []
          if (blackList.includes('expe') && userInfo.vip === 2 && userInfo.super_vip_type === 'expe') {
            return true
          }
          if (blackList.includes('year') && userInfo.vip === 2 && userInfo.super_vip_type === 'year') {
            return true
          }
          if (blackList.includes('forever') && userInfo.vip === 2 && userInfo.super_vip_type === 'forever') {
            return true
          }
          if (blackList.includes('normal') && userInfo.vip !== 2) {
            return true
          }
          return false
        },
      })
    }
  })
}

const loadViewpaymentByUserTag = (data: ModData<{ switch?: '1' | '0' }>) => {
  AppStore.viewpaymentByUserTag = data.datas?.[0]?.properties.switch === '1'
}

/** 加载首页浮动按钮显示配置 */
const loadFloatImgConfig = (data: ModData<{ key: string; view: '1' | any }>) => {
  AppStore.gameReplaceFloatVisible = data.datas?.[0]?.properties.view === '1'
}

/** 加载活动黑名单配置 */
const loadActivityChannel = (data: ModData<{ key: string; channel: string }>) => {
  AppStore.activityChannel = data.datas.map(d => d.properties)
}

/** 加载选择微信支付方式的提示 */
const loadPayTips = (
  data: ModData<{ gog商城: string; letplay商城: string; letplay客户端: string; 管家客户端: string; 新版管家: string }>,
) => {
  if (data.datas && data.datas[0]) {
    AppStore.switchPayTips = data.datas[0].properties
  }
}

/** 绑定的云游戏时长商品 */
const loadBindingCloudGameTime = (data: ModData<{ goods: string }>) => {
  const goods = data?.datas?.[0]?.properties?.goods
  if (goods) {
    AppStore.bindingCloudGameTime = goods
  }
}

/** 加载不展示微信登录路口的渠道 */
const loadNotViewWechat = (data: ModData<{ channel: string }>) => {
  AppStore.notViewWechatEntry = data.datas.map(d => d.properties.channel)
}

/**加载购买类型配置*/
const LoadBuyModeConfig = (
  data: ModData<{ mode: 2 | 3; cn: string; name: string; gameid?: string; cn2: string; limitgameid?: string }>,
) => {
  const buyTypeDesc: {
    [key in 3 | 2]?: { tips: string; name: string; games: number[]; tips2: string; LimitGames: number[] }
  } = {}
  data.datas.forEach(d => {
    buyTypeDesc[d.properties.mode] = {
      tips: d.properties.cn,
      name: d.properties.name,
      tips2: d.properties.cn2,
      games: (d.properties.gameid && d.properties.gameid.split(',').map(Number)) || [],
      LimitGames: d.properties.limitgameid?.split(',').map(Number) || [],
    }
  })
  AppStore.buyModeConfig = buyTypeDesc
}
/**加载游戏平台配置*/
const LoadGamePlatformConfig = (data: ModData<any>) => {
  const config: { [key in GamePlatform]?: { url: string; md5: string; extend: string } } = {}
  for (const key of data.datas) {
    config[key.properties.platform as GamePlatform] = {
      md5: key.properties.md5,
      extend: key.properties.name,
      url: key.properties.url,
    }
  }
  AppStore.GamePlatformConfig = config
}
/**加载购买类型标题*/
const LoadBuyTitleConfig = (data: ModData<{ [key in 'ver' | 'type']?: string }>) => {
  if (data.datas[0]) {
    AppStore.BuyTypeTitle = data.datas[0].properties
  }
}
/** 加载加速器测试配置 */
const LoadSpeedTestConfig = (
  data: ModData<{ channelspeeddownload: string; channeldownloadname: string; channelmd5: string; channel: string }>,
) => {
  if (!data.datas[0]) {
    return
  }
  const temp = data.datas[0].properties
  if (!temp) {
    return
  }
  const channel = GetChannel()
  const wChannelList = temp.channel?.split(',') || []
  const isW = wChannelList.includes(channel)
  /** 配置取反 */
  if (!isW) {
    AppStore.testSpeedConfig = temp
  }
}
/**加载协议配置*/
const LoadAgreementConfig = (data: ModData<{ keyword: AgreementType; title: string; content: string }>) => {
  data.datas.forEach(d => {
    AppStore.AgreementConfig[d.properties.keyword] = { title: d.properties.title, content: d.properties.content }
  })
}
/**Steam版 Uplay 游戏提示*/
const SteamVerUplayGameTips = (data: ModData<{ content: string; gameid: string }>) => {
  const res = data.datas[0]
  if (res) {
    const Games = res.properties.gameid.split(',')
    AppStore.SteamVerUplayGameInfo = { Games, content: res.properties.content }
  }
}
/**获取退款承诺配置*/
const RefundPromiseConfig = (
  data: ModData<{ newContent: string; description: string; newLogo: string; colour: string }>,
) => {
  AppStore.RefundPromiseConfig = data.datas.map(item => item.properties)
}

/**没有存档游戏提示游戏提示*/
const NotArchiveGamesConfig = (data: ModData<{ content: string; gameid: string }>) => {
  const res = data.datas[0]
  if (res) {
    const Games = res.properties.gameid.split(',').map(Number)
    AppStore.NotArchiveConfig = { Games, content: res.properties.content }
  }
}

/**加载平台启动配置项*/
const LoadStartPlatformConfig = (data: ModData<TStartPlatformConfig>) => {
  data.datas.forEach(d => {
    AppConfig.StartPlatformConfig[d.properties.platform] = {
      ErrorMsg: d.properties.error_msg,
      CommandLine: d.properties.commandline,
    }
  })
}
/**加载加速器配置*/
const LoadJsqConfig = (data: ModData<any>) => {
  const res = data.datas[0]
  if (res) {
    AppStore.JsqConfig = res.properties
  }
}
/** 加载充值云游戏时长配置 */
// const loadCloudTimeConfig = (data: ModData<any>) => {
//   if (data) {
//     AppStore.cloudTimeConfig = data.datas.map(d => d.properties)
//   }
// }
/**获取 CMS 缓存版本*/
export const getCMSVersion = (): Promise<string> => {
  return new Promise(resolve => {
    if (AppStore.CMSVersion) {
      resolve(AppStore.CMSVersion)
    } else {
      const WaitCMSVersion = reaction(
        () => AppStore.CMSVersion,
        version => {
          WaitCMSVersion()
          resolve(version!)
        },
      )
    }
  })
}
/** 加载需要隐藏订单信息的商品配置 */
export const loadNeedHideOrderInfoConfig = async () => {
  const data = await getGoodsIdForHideOrder.Execute()
  AppStore.needHideOrderInfoGoodsIds = data?.split(',') || []
}
/**客服*/
export const CustomerService = (flag?: boolean) => {
  return {
    onClick: () => OpenCustomerService(flag),
  }
}

/**vip客服*/
export const CustomerVipService = () => {
  return {
    onClick: () => OpenCustomerService(),
  }
}

/** 加载启动超时配置*/
const LoadStartTimeOutConfig = (data: ModData<any>) => {
  const res = data.datas[0]
  if (res) {
    AppStore.StartTimeoutConfig = res.properties
  }
}
/** 加载启动游戏超时配置*/
const LoadStartGameTimeOutConfig = (data: ModData<{ Platform?: GamePlatform; time: string }>) => {
  data.datas.forEach(d => {
    if (d.properties.Platform) {
      AppStore.StartGameTimeoutConfig[d.properties.Platform] = Number(d.properties.time)
    } else {
      AppStore.StartGameTimeoutConfig.default = Number(d.properties.time)
    }
  })
}
/**卸载迈克菲*/
export const UninstallMkf = () => {
  if (window.FuluApp) {
    isLogged().then(() => {
      const config = AppStore.GamePlatformConfig[101]
      config &&
        window.FuluApp!.JSNotifyCppFunc('notify_gameplatform_download_info', 101, config.md5, config.url, config.extend)
    })
  } else {
    needClient()
  }
}

/**
 * 是否登录
 */
export const isLogged = async () => {
  const token = getPhpToken()
  if (token) {
    return token
  }
  ShowLoginModal()
  throw new Error('您还未登录!')
}

/**
 * 判断当前版本是否大于指定版本
 * @param ver 指定版本
 */
export const CompareWithCurrentVersion = (ver: [number, number, number, number]) => {
  if (AppConfig.Version) {
    const CurrentVersion = AppConfig.Version.split('.').map(d => Number(d))
    return CompareVersion(CurrentVersion, ver)
  }
  return false
}

/**
 * 需要安装客户端
 * */
export const needClient = () => {
  DDModal.warn({
    title: '提示',
    content: '为保障你的游戏账号安全，请下载PC端客户端后使用该功能！点击“确定”下载最新版本',
    okText: '确定',
    zIndex: 1060,
    onOk: () => {
      DownloadClient()
    },
  })
}

/** 下载存档 */
export const downloadArchive = async (d: TFinalArchive, e?: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
  e?.stopPropagation()
  if (Store.isInClient) {
    const orderNo = d.key.split('#')[1]
    const path = d.key.split('#')[0]
    if (d.diy === 0) {
      reportCloudArchivesDownloadNumHS.Execute({ orderNo: d.orderNo || '' })
    }
    await AppStore.cloudSaveInstance?.noticeClient('DownloadCloudArchives', {
      order_no: orderNo,
      oss_path: path,
      name: d.name,
      archives_create_time: d.time / 1000,
      is_save_down_info: 1,
      save_archives_count: 999,
      oss_md5: d.md5,
    })
  } else {
    needClient()
  }
}

export const LoadNotShowVerify = (data: ModData<{ channel: string; switch: string }>) => {
  const info = data.datas[0]
  if (info) {
    if (info.properties.switch === '0') {
      AppStore.NotShowVerify = info.properties.channel.split(',')
    }
  }
}

type NotificationConfig = {
  autoCloseTime: string
  height: string
  width: string
  source: string
  sourceType: 'image' | 'video'
  target: 'in' | 'out'
  text: string
  url: string
}

/** 打开广告 */
export const openNotification = async (token?: string) => {
  const phpToken = token || getPhpToken()
  if (window.location.pathname === '/notification' || !phpToken || sessionStorage.getItem('opennotification')) {
    return
  }
  const simpleshqNotificationConfig = await useWaitModData('simpleshq_Notification_config')
  const config = simpleshqNotificationConfig?.[0]
  if (config) {
    sessionStorage.setItem('opennotification', 'true')
    window.FuluApp?.JSNotifyCppFunc(
      'show_popup_window',
      `${window.location.origin}/notification`,
      config.width,
      config.height,
    )
  }
}

/** 等待用户登录 */
export const delayUserLogin = () => {
  if (UserInfoHS.SuccessResult) {
    return true
  }
  return new Promise((res, rej) => {
    const waitUserLogin = reaction(
      () => UserInfoHS.SuccessResult,
      async userInfo => {
        res(true)
        waitUserLogin()
      },
    )
  })
}

/** 判断url上面有没有 */
export const loadLinkGame = async (linkgameid: number | string | null) => {
  if (!linkgameid) {
    return
  }
  const token = getPhpToken()
  /** 用户未登录直接跳转首页 */
  if (!token) {
    if (checkIsDouyinChannel()) {
      return commonJump('/store')
    }
    return commonJump('/home')
  }
  try {
    const gameLibraryGame = await getGameLibraryByAppIdHS.Execute({ appid: linkgameid })
    if (!gameLibraryGame) {
      throw new Error('没有该游戏')
    }
    const result = await Promise.race([delayUserLogin(), sleep(5 * 1000)])
    if (result === 'sleep') {
      throw new Error('用户登录超时')
    }
    const gameLibraryList = await getGameLibraryListHS.Execute({ pageNo: 1, pageSize: 999 })
    const hasCurrentGame = gameLibraryList.find(d => d.gameLibraryId === gameLibraryGame.gameLibraryId)
    if (!hasCurrentGame) {
      throw new Error('没有该游戏')
    }
    GameLibraryStore.currentGameLibraryGame = {
      ...gameLibraryGame,
    }
    commonJump('/my-game')
    return true
  } catch (error) {
    if (checkIsDouyinChannel()) {
      return commonJump('store')
    }
    return commonJump('/home')
  }
}

/** 阻塞函数 */
export const sleep = async (time: number) => {
  return new Promise((res, rej) => {
    setTimeout(() => {
      res('sleep')
    }, time)
  })
}

export const getClientName = () => {
  const Query = new URLSearchParams(location.search.substr(1, location.search.length))
  return Query.get('SetupName')
}

/** 用户引导 */
export const userGuidance = async () => {
  const firstIn = localStorage.getItem('firstIn')
  localStorage.setItem('firstIn', '1')
  const clientName = getClientName()
  if (!firstIn) {
    AppStore.isFirstOpenClient = true
    // AppStore.welcomeModalVisible = false //首先不开启打开新人领游戏弹框
  } else {
    AppStore.isFirstOpenClient = false
    /** 非首次打开 */
    if (getPhpToken()) {
      /** 已登录过 */
      // viewActiveModal()
    } else {
      /** 未登录过 */
      await isLogged()
    }
  }
  //4749
  // clientName = 'bid0-lid1-steam.game_steam9_1.0.0.1659@nbant@gog'
  if (clientName) {
    let buyGameId: string | null | number = clientName.split('-')[0]
    buyGameId = buyGameId?.includes(bidStr) ? buyGameId.match(new RegExp(`${bidStr}(\\d+)`))?.[1] || '' : null
    let lookGameId: string | null | number = clientName.split('-')[1]
    lookGameId = lookGameId?.includes(lidStr) ? lookGameId.replace(lidStr, '') : null
    console.log('UIController gameId', buyGameId, lookGameId)
    //购买标识 4749
    if (buyGameId && buyGameId !== '0') {
      /** 已购买游戏 */
      try {
        statisticsApiHS.Execute()
      } catch (error) {}
      if (!firstIn) {
        AppStore.firstInGameId = Number(buyGameId) //购买标识符
        // history.push('/my-game')
        return
      }
    }
  }
}

/** 计算文本长度 */
export const getTextWidth = (text: string, style?: Partial<{ fontSize: string; fontWeight: string }>) => {
  const DOM = document.createElement('span')
  if (style) {
    DOM.style.fontSize = style.fontSize || '12px'
    DOM.style.fontWeight = style.fontWeight || '400'
    DOM.style.whiteSpace = 'nowrap'
  }
  DOM.innerText = text
  document.body.appendChild(DOM)
  const width = DOM.offsetWidth
  document.body.removeChild(DOM)
  return width
}

/** 获取平台&游戏的cdk使用帮助图片 */
export const getPlatFormCdkHelp = async () => {
  const simpleclientCdkHelpUrl = await useWaitModData<CDKCourse>('simpleclient_cdk_help_url')
  if (simpleclientCdkHelpUrl && simpleclientCdkHelpUrl.length > 0) {
    AppStore.platFormProp = simpleclientCdkHelpUrl
  }
}

/** 获取当前服务器时间 */
export const getCurrentServerTime = async () => {
  const res = await DWBeijingTime.Execute()
  return Number(res.time) * 1000
}

/** 避免精度问题的加法 */
export const sum = (a: number, b: number) => {
  let r1
  let r2
  try {
    r1 = a.toString().split('.')[1].length
  } catch (e) {
    r1 = 0
  }
  try {
    r2 = b.toString().split('.')[1].length
  } catch (e) {
    r2 = 0
  }
  const m = Math.pow(10, Math.max(r1, r2))
  return (a * m + b * m) / m
}

/** 避免精度问题的减法 */
export const subtract = (a: number, b: number) => {
  let r1
  let r2
  try {
    r1 = a.toString().split('.')[1].length
  } catch (e) {
    r1 = 0
  }
  try {
    r2 = b.toString().split('.')[1].length
  } catch (e) {
    r2 = 0
  }
  const m = Math.pow(10, Math.max(r1, r2))
  const n = r1 >= r2 ? r1 : r2
  return Number(((a * m - b * m) / m).toFixed(n))
}

/** 避免精度问题的乘法 */
export const multiply = (a: number, b: number) => {
  let m = 0
  const s1 = a.toString()
  const s2 = b.toString()
  try {
    m += s1.split('.')[1].length
  } catch (e) {}
  try {
    m += s2.split('.')[1].length
  } catch (e) {}
  return (Number(s1.replace('.', '')) * Number(s2.replace('.', ''))) / Math.pow(10, m)
}

export const division = (a: number, b: number) => {
  let t1 = 0
  let t2 = 0
  try {
    t1 = a.toString().split('.')[1].length
  } catch (e) {}
  try {
    t2 = b.toString().split('.')[1].length
  } catch (e) {}
  const r1 = Number(a.toString().replace('.', ''))
  const r2 = Number(b.toString().replace('.', ''))
  return multiply(r1 / r2, Math.pow(10, t2 - t1))
}

/** 前往下单页 */
export const toBuyDetail = (gameId: number | string, accountType: number | string, search?: string) => {
  history.push(`/store/goods/${gameId}/buy/${accountType}${search || ''}`)
}

/** 下单页的地址 */
export const getBuyDetailUrl = (gameId: number | string, accountType: number | string, search?: string) => {
  return `/store/goods/${gameId}/buy/${accountType}${search || ''}`
}

/** 前往礼包下单页 */
export const toPackageBuyDetail = (packageId: number | string, search?: string) => {
  history.push(`/store/goods/${packageId}/buy/88${search || ''}`)
}

/** 礼包下单页地址 */
export const getPackageBuyDetailUrl = (packageId: number | string) => {
  return `/store/goods/${packageId}/buy/88`
}

/** 前往vip下单页地址 */
export const toVipBuyDetailUrl = (vipId: number | string, search?: string) => {
  history.push(`/home/vip/goods/${vipId}/buy/66${search || ''}`)
}

/** 前往会员捆绑包下单页地址 */
export const toVipPackBuyDetailUrl = (vipId: number | string, search?: string) => {
  history.push(`/home/vip/goods/${vipId}/buy/68${search || ''}`)
}

/** 集合包详情页 */
export const toPackageDetailUrl = (id: number | string) => {
  history.push(`/store/package/${id}`)
}

/** vip下单页地址 */
export const getVipBuyDetailUrl = (vipId: number | string) => {
  return `/home/vip/goods/${vipId}/buy/66`
}
/** 前往存档下单页 */
export const toArchiveBuyDetail = (archiveId: number | string, search?: string) => {
  history.push(`/store/goods/${archiveId}/buy/44${search || ''}`)
}

/** todo:前往汉化包下单页 */
export const toChinesePackageBuyDetail = (id: number | string, search?: string) => {
  history.push(`/store/goods/${id}/buy/50${search || ''}`)
}

/** todo:前往MOD下单页 */
export const toMODBuyDetail = (id: number | string, search?: string) => {
  history.push(`/store/goods/${id}/buy/60${search || ''}`)
}

/** 前往加速器下单页地址 */
export const toBoosterBuyDetailUrl = (boosterId: number | string, search?: string) => {
  history.push(`/store/goods/${boosterId}/buy/77${search || ''}`)
}

/** 加速器下单页地址 */
export const getBoosterBuyDetailUrl = (boosterId: number | string) => {
  return `/store/goods/${boosterId}/buy/77`
}

/** 前往云游戏下单页 */
export const toCloudTimeBuyDetailUrl = (cloudGameId: number | string, search?: string) => {
  history.push(`/store/goods/${cloudGameId}/buy/99${search || ''}`)
}

/** 云游戏下单页地址 */
export const getCloudTimeBuyDetailUrl = (cloudGameId: number | string) => {
  return `/store/goods/${cloudGameId}/buy/99`
}

/** 集合包详情页 */
export const getPackageDetailUrl = (id: number | string, search?: string) => {
  return `/store/package/${id}${search || ''}`
}

/** 激活码详情页 */
export const getCDKDetailUrl = (id: number | string, search?: string) => {
  return `/store/CDK/${id}${search || ''}`
}

/** 激活码详情页 */
export const toCDKDetailUrl = (id: number | string, search?: string) => {
  history.push(`/store/CDK/${id}${search || ''}`)
}

/** todo:前往我的背包 */
export const toMyKnapsack = (
  knapsackTab: 'archive' | 'MOD' | 'chinese',
  id: number | string,
  route?: string,
  gameId?: string,
) => {
  history.push(`/User/knapsack?knapsackTab=${knapsackTab}&goodsId=${id}&route=${route || ''}&gameId=${gameId || ''}`)
}

/** 前往商品详情页 */
export const toStoreGameDetail = (
  gameLibraryId: number | string,
  gameId: number | string,
  key?: TStoreGameNavKey | string,
  search?: string,
  ornamentId?: number | string,
) => {
  if (
    localStorage
      .getItem('newGameDetailId1')
      ?.split(',')
      .includes(gameLibraryId + '')
  ) {
    history.push(
      `/store/newGame2/${gameLibraryId}/${gameId}/${key || ''}${ornamentId ? `/${ornamentId}` : ''}${
        search ? `${search}&style=2` : '?styled=2'
      }`,
    )
  } else {
    history.push(
      `/store/newGame5/${gameLibraryId}/${gameId}/${key || ''}${ornamentId ? `/${ornamentId}` : ''}${
        search ? `${search}&style=5` : '?styled=5'
      }`,
    )
  }
}

/** 前往商品详情页 */
export const toStoreGameDetailByReplace = (
  gameLibraryId: number | string,
  gameId: number | string,
  key?: TStoreGameNavKey | string,
  search?: string,
  ornamentId?: number | string,
) => {
  if (
    localStorage
      .getItem('newGameDetailId1')
      ?.split(',')
      .includes(gameLibraryId + '')
  ) {
    history.replace(
      `/store/newGame2/${gameLibraryId}/${gameId}/${key || ''}${ornamentId ? `/${ornamentId}` : ''}${
        search ? `${search}&style=2` : '?style=2'
      }`,
    )
  } else {
    history.replace(
      `/store/newGame5/${gameLibraryId}/${gameId}/${key || ''}${ornamentId ? `/${ornamentId}` : ''}${
        search ? `${search}&style=5` : '?styled=5'
      }`,
    )
  }
}

/** 前往下单成功页 */
export const toBuySuccess = (orderNo: string | number | undefined, payType: TPayWay, search?: { [p: string]: any }) => {
  console.log('toBuySuccess', orderNo)
  if (!orderNo) {
    return
  }
  history.push(
    `/success?orderNo=${orderNo}${payType ? `&payType=${payType}` : ''}${search ? `&${stringify(search)}` : ''}`,
  )
}

/** 商品详情页地址 */
export const getStoreGameDetailUrl = (
  gameLibraryId: number,
  gameId: number,
  key?: TStoreGameNavKey,
  search?: string,
  ornamentId?: number | string,
) => {
  if (
    localStorage
      .getItem('newGameDetailId1')
      ?.split(',')
      .includes(gameLibraryId + '')
  ) {
    return `/store/newGame2/${gameLibraryId}/${gameId}/${key || ''}${ornamentId ? `/${ornamentId}` : ''}${
      search ? `${search}&style=2` : '?style=2'
    }`
  } else {
    return `/store/newGame5/${gameLibraryId}/${gameId}/${key || ''}${ornamentId ? `/${ornamentId}` : ''}${
      search ? `${search}&style=5` : '?style=5'
    }`
  }
}
/** 公用跳转方法 */
export const commonJump = (url: string, out?: boolean) => {
  if (!out) {
    return history.push(url)
  }
  if (Store.isInClient) {
    return window.FuluApp!.JSNotifyCppFunc('open_url', url)
  }
  window.open(url, '_blank')
}

/** 打开协议弹窗 */
export const showAgreementModal = (type: AgreementType) => {
  Store.protocolVisible = true
  Store.protocolType = type
}

export const checkNextModal = async () => {
  const isShowNewModal = await chcekIsNewUser()
  console.log(`isShowNewModal:`, isShowNewModal)

  if (!isShowNewModal && AppStore.authSwitchConfig?.loginFlag) {
    isShowAuthModal(true)
  }
}

/**
 * 新人礼包弹出机制（新）
 * 如果没有首充（并且没有设置不再提醒）： 弹出新人礼包弹框
 * 如果有首充过，再判断是否需要弹出新人优惠券弹窗
 */
// export const chcekIsNewUser = async () => {
//   try {
//     const userInfo = UserInfoHS.SuccessResult
//     /** 当前用户是标记过不再提醒 */
//     const hasMark = await queryUserMarkHS.Execute({ name: 'firstChargeModal', subjectId: userInfo?.id || 0 })
//     if (hasMark && hasMark.name === 'firstChargeModal') {
//       return false
//     }

//     const isReceiveNewUserRes = await isReceiveNewUserHS.Execute({ activityNo: 'AT5553844368444957006' })
//     const couponRes = await grantCouponHS.Execute()
//     /** 没有首充过 */
//     if (
//       !isReceiveNewUserRes
//       // && !couponRes.reviceCoupon &&
//       // couponRes.couponActivityInfoVoList &&
//       // couponRes.couponActivityInfoVoList.length > 0
//     ) {
//       AppStore.newcomerVisisble = true
//       return true
//     }
//     /** 有首充过 */
//     if (
//       couponRes &&
//       !couponRes.reviceCoupon &&
//       couponRes.couponActivityInfoVoList &&
//       couponRes.couponActivityInfoVoList.length > 0
//     ) {
//       AppStore.couponVisible1 = true
//       return true
//     }
//     return false
//   } catch (error) {
//     console.log(error, '检测是否领取过新人礼包')
//     return false
//   }
// }

const isShowCase1 = async () => {
  const simpleChristmasConfig = await useWaitModData('simple_christmas_config')
  const isShow = simpleChristmasConfig?.[0]?.case1visible === '1' && !localStorage.getItem('christmas-case1')
  localStorage.setItem('christmas-case1', '1')
  console.log('checkIsNewUser isShowCase1', isShow)
  return isShow
}

/**
 * 上面的实现为新人礼包的弹出机制，双旦活动移除新人礼包，替换为新弹框弹出机制
 * 在这里对checkIsNewUser方法进行总体重写，需要回滚的话可以直接使用上面的方法
 */
export const chcekIsNewUser = async () => {
  console.log('checkIsNewUser start')
  try {
    const activityUserPurchaseInfo = await DWgetActivityUserPurchaseInfo.Execute()
    console.log('checkIsNewUser data', activityUserPurchaseInfo)
    const registerDiff = moment(BeijingTime.now()).valueOf() - moment(activityUserPurchaseInfo.regTime).valueOf()
    console.log(
      'initCheck checkIsNewUser diff',
      registerDiff,
      moment().valueOf(),
      moment(activityUserPurchaseInfo.regTime).valueOf(),
    )
    const HOUR_24 = 1000 * 60 * 60 * 24
    const HOUR_48 = HOUR_24 * 2
    const HOUR_168 = HOUR_24 * 7

    /** case1: 针对注册24h内未付费的新用户/针对买过共享且未买永久会员(不排除退款的,买过共享的订单数据是指功能上线后)，注册时间<48h */

    /** 注册24h内未付费的新用户 */
    const in24Hour = registerDiff >= 0 && registerDiff < HOUR_24
    if (!activityUserPurchaseInfo.payingUser && in24Hour) {
      (await isShowCase1()) && (AppStore.christmasCase1Visible = true)
      console.log('initCheck checkIsNewUser 注册24h内未付费的新用户', AppStore.christmasCase1Visible)
      return AppStore.christmasCase1Visible
    }

    /** 买过共享且未买永久会员 */
    const between0And48 = registerDiff >= 0 && registerDiff < HOUR_48
    if (!activityUserPurchaseInfo.purchaseVip && activityUserPurchaseInfo.purchaseShare && between0And48) {
      (await isShowCase1()) && (AppStore.christmasCase1Visible = true)
      console.log('initCheck checkIsNewUser 买过共享且未买永久会员', AppStore.christmasCase1Visible)
      return AppStore.christmasCase1Visible
    }

    /** case2: 针对24h<=注册时间<=168h未付费的新用户 */
    const between24And168 = registerDiff >= HOUR_24 && registerDiff < HOUR_168
    if (!activityUserPurchaseInfo.payingUser && between24And168) {
      const activityConfig = await getActivityConfigInfoHS.Execute({ activityNo: 'AT5685295899444851355' })
      const isInActivityTime =
        activityConfig.activityState === 1 &&
        moment(activityConfig.endTime).valueOf() > moment(BeijingTime.now()).valueOf() &&
        moment(BeijingTime.now()).valueOf() > moment(activityConfig.beginTime).valueOf()
      if (!localStorage.getItem('christmas-case2') && isInActivityTime) {
        console.log('initCheck checkIsNewUser 针对24h<=注册时间<=168h未付费的新用户')
        localStorage.setItem('christmas-case2', '1')
        AppStore.christmasCase2Visible = 'case2'
        window.sensorsdataReportParams?.('BoxClient_Redenvelopes_view', { scene: 'Unpaid' })
      }
      return !!AppStore.christmasCase2Visible
    }

    /** case3:针对买过共享且未买永久会员(不排除退款的，买过共享的订单数据是指功能上线后)，注册时间>=48h */
    const greaterThan48 = registerDiff >= HOUR_48
    if (!activityUserPurchaseInfo.purchaseVip && activityUserPurchaseInfo.purchaseShare && greaterThan48) {
      const activityConfig = await getActivityConfigInfoHS.Execute({ activityNo: 'AT5685295228150690459' })
      const isInActivityTime =
        activityConfig.activityState === 1 &&
        moment(activityConfig.endTime).valueOf() > moment(BeijingTime.now()).valueOf() &&
        moment(BeijingTime.now()).valueOf() > moment(activityConfig.beginTime).valueOf()
      if (!localStorage.getItem('christmas-case3') && isInActivityTime) {
        console.log(
          'initCheck checkIsNewUser 针对买过共享且未买永久会员(不排除退款的，买过共享的订单数据是指功能上线后)，注册时间>=48h',
        )
        localStorage.setItem('christmas-case3', '1')
        AppStore.christmasCase2Visible = 'case3'
        window.sensorsdataReportParams?.('BoxClient_Redenvelopes_view', { scene: 'paid' })
      }
      return !!AppStore.christmasCase2Visible
    }

    return await loadActivity23616Config()
  } catch (error) {
    return false
  }
}

/** 获取userInfo ,UserInfoHS已经其他地方请求过,等待返回即可 */
export const getUserInfoAsync = () => {
  return new Promise<UserInfo | null>(resolve => {
    const data = UserInfoHS.SuccessResult
    if (data) {
      resolve(data)
    } else {
      const disposer = reaction(
        () => UserInfoHS.SuccessResult,
        info => {
          resolve(info)
          disposer()
        },
      )
    }
  })
}

/**
 * 各种弹窗控制
 * 只会弹一种窗，弹出一个窗后，后续弹窗流程终止
 */
export const checkModal = async () => {
  if (!getPhpToken()) {
    return
  }
  /** 抖音渠道包不需要弹窗 */
  if (checkIsDouyinChannel()) {
    commonJump('/store')
    return
  }
  /**
   * 需要串联检测弹窗的函数，单项返回true，即会中断后续其它弹窗流程
   * 后续还有其它弹窗流程检测， 在此数组添加即可
   */
  const checkArr = [
    /** 判断是否永久会员， 跳转页面，这个不是弹窗，属于登录后的逻辑判断，也放在此处(暂时隐藏) */
    // async () => {
    //   console.log('initCheck 永久会员跳转会员页判断')
    //   if (!AppStore.isPageJump && ['/', '/home'].includes(window.location.pathname)) {
    //     checkForeverVipPageJump()
    //   }
    //   return false
    // },
    /** 是否显示实名认证弹窗 */
    async () => {
      console.log('initCheck checkModal 实名弹窗判断')
      const loginFlag = await new Promise(resolve => {
        if (!AppStore.authSwitchConfig) {
          //等待cms配置返回后再判断
          const disposer = reaction(
            () => AppStore.authSwitchConfig?.loginFlag,
            v => {
              resolve(v)
              disposer()
            },
          )
        } else {
          resolve(AppStore.authSwitchConfig.loginFlag)
        }
      })
      if (loginFlag && (await isShowAuthModal(true))) {
        //等待实名完成或关闭后进行后续弹窗
        await awaitRealNameAuthModal()
      }
      return false
    },
    /** 是否显示年卡会员升级永久会员弹窗 */
    async () => {
      console.log('initCheck checkModal 年卡会员升级永久会员弹窗判断')
      return await checkYearUpdateForeverModal('home')
    },

    /** 是否显示战令弹窗 */
    async () => {
      console.log('initCheck checkModal 战令弹窗判断')
      return await checkUserIsHaveQualification()
    },

    /** 是否显示双旦活动弹窗（case1：新人永久会员券，case2:次日留存券，case3）*/
    async () => {
      console.log('initCheck checkModal 双旦活动弹窗判断')
      return await chcekIsNewUser()
    },

    /** 是否显示非会员升级永久会员活动弹窗 */
    async () => {
      console.log('initCheck checkModal 非会员升级永久会员弹窗判断')
      return await checkUpdateVipModal()
    },
  ]

  for (const check of checkArr) {
    let checkResult
    try {
      checkResult = await check()
      console.log('initCheck checkModal result', checkResult)
    } catch (e) {
      console.log('checkModal checkResult err', e)
      continue
    }
    if (checkResult) {
      break
    }
  }
}

/**
 *获取焦点隐藏placeholder，失去焦点显示placeholder
 */
export const hackPlaceholder = () => {
  document.addEventListener(
    'focusin',
    e => {
      const el: HTMLInputElement = e.target as HTMLInputElement
      const placeholder = el?.getAttribute('placeholder') ?? ''
      if (!el || !placeholder) {
        return
      }
      el.setAttribute('placeholder', '')
      const onFocusout = () => {
        el.setAttribute('placeholder', placeholder)
        el.removeEventListener('focusout', onFocusout)
      }
      el.addEventListener('focusout', onFocusout, false)
    },
    false,
  )
}

/** 设置屏幕缩放 */
export const setZoom = () => {
  try {
    const Query = new URLSearchParams(location.search.substr(1, location.search.length))
    const zoom = Query.get('zoom') || localStorage.getItem('zoom')
    if (!zoom) {
      return
    }
    localStorage.setItem('zoom', zoom)
    const target: any = document.body.style
    target.zoom = zoom
  } catch (error) {
    console.log('设置zoom失败:', error)
  }
}

export const loadSpikeSpecialConfig = async () => {
  const res = await DWgetBargainConfig.Execute()
  if (res.enable) {
    AppStore.spikeSpecialConfig = res
    return
  }
  AppStore.spikeSpecialConfig = null
}

export const preBuyGames = async (id: number, marketingType?: 'alone' | 'share_online') => {
  const [detail, hasAccountList, currentServerTime] = await Promise.all([
    DWGameDetailHttp.Execute({ game_id: id, filterWithHiddenPeriod: true }),
    getGamePlayListHS.Execute({ gameId: id }),
    getCurrentServerTime(),
  ])

  /** 有账号，可以直接启动游戏 */
  if (hasAccountList.length > 0) {
    let hasShareAccount = false
    let hasAloneAccount = ''
    hasAccountList.find(d => {
      if (d.type === 7) {
        hasShareAccount = true
      }
      if (d.type === 1) {
        hasAloneAccount = d.ctime
      }
      return hasShareAccount && hasAloneAccount
    })
    /** 有独享账号 */
    if (hasAloneAccount && (!marketingType || marketingType === 'alone')) {
      return new Promise((res, rej) => {
        Modal.confirm({
          className: 'custom',
          content: `${detail.product_name}您已在${moment(hasAloneAccount).format(
            'YYYY年MM月DD日',
          )}购买过独享，是否重复购买?`,
          centered: true,
          okText: '我要购买',
          onOk: () => {
            res(true)
          },
          cancelText: '放弃',
          onCancel: () => {
            res(false)
          },
        })
      })
    }
    /** 有共享账号 */
    if (hasShareAccount && (!marketingType || marketingType === 'share_online')) {
      message.warn('你已拥有该游戏，可前往游戏库启动')
      return false
    }
    return true
    /** 未拥有 */
  } else {
    /**判断是否需要缴纳保证金 */
    const [forbidInfo, amount] = await Promise.all([
      ForbidInfoHS.Execute({ game_id: detail.id, page: 'start', channel: GetChannel() }),
      depositAmountHS.Execute({ gameId: detail.id, channel: GetChannel() }),
    ])
    if (forbidInfo.forbid === 1 || forbidInfo.apply_status !== 1) {
      showNeedDeposit(detail.platform, amount || forbidInfo.amount, detail.id)
      return false
    }

    /** 有vip添加权限，则尝试直接添加入库并跳转至我的游戏局 */
    const userInfo = UserInfoHS.SuccessResult
    const isExpeVip = userInfo?.vip === 2 && userInfo.super_vip_type === 'expe'
    const isYearVip = userInfo?.vip === 2 && userInfo.super_vip_type === 'year'
    const isForeverVip = userInfo?.vip === 2 && userInfo.super_vip_type === 'forever'
    const hasShareVipPower =
      detail.cols?.newHotGame === '1' ? isYearVip || isForeverVip : isExpeVip || isYearVip || isForeverVip
    const vipAddDisabled = detail?.cols?.vipNotAddGoodsEndTime
      ? moment(detail?.cols?.vipNotAddGoodsEndTime).diff(moment(currentServerTime)) > 0
      : false
    console.log(hasShareVipPower, 'hasShareVipPower')
    console.log(vipAddDisabled, 'vipAddDisabled')
    console.log(marketingType, 'marketingType')

    // return
    if (hasShareVipPower && !vipAddDisabled && (!marketingType || marketingType === 'share_online')) {
      Modal.confirm({
        title: '温馨提示',
        className: 'custom',
        content: '亲爱的玩家，您是我们尊贵的会员，当前游戏可免费添加到您的游戏库中，点击确认是否添加入库？',
        okText: '确认添加',
        onOk: async close => {
          close()
          try {
            await DWAddGameHttp.Execute({ game_id: detail.id, game_mode: 1 })
            GameLibraryStore.currentGameLibraryGame = {
              gameLibraryId: detail.gameLibraryId,
              gameLibraryImg: '',
              gameLibraryName: detail.product_name,
              appId: '',
            }
            commonJump('/my-game')
          } catch (error) {
            message.warn(error.message)
          }
        },
      })
      return false
    }
    return true
  }
}

export const runModifierClient = (data?: TModifierDownLoadConfig & { extend?: string }) => {
  if (!data) {
    return
  }
  const {
    modifierdownload,
    productid,
    downloadname,
    downloadextname,
    md5,
    installpath,
    relativepath,
    cmdline,
    installparam,
    shortcut,
    RegInstallPath,
    isDefault,
    extend,
    gameId,
  } = data
  const userInfo = UserInfoHS.SuccessResult
  console.log('userInfo', userInfo?.bindMobile)
  if (window.FuluApp) {
    window.FuluApp.JSNotifyCppFunc(
      'start_3rd_speed',
      productid,
      downloadname,
      downloadextname,
      modifierdownload,
      md5,
      installpath,
      relativepath,
      cmdline,
      installparam,
      shortcut,
      RegInstallPath,
      extend ||
        JSON.stringify({
          userInfo: null,
          source: 'normal',
          mobile: userInfo?.bindMobile ? '' : userInfo?.mobile ?? '',
          token: getPhpToken(),
        }),
      gameId || '',
    )
  } else {
    needClient()
  }
}

// 已废弃
/*9+1活动弹框*/
// export const viewActiveModal = async () => {
//   const nineOneModal = sessionStorage.getItem('nine_one_modal')
//   if (getPhpToken()) {
//     const result = await getActive1ConfigHS.Execute({ activityType: 'nine_one' })
//     if (result.lastTime > 0 && !nineOneModal) {
//       sessionStorage.setItem('nine_one_modal', '1')
//       //暂时取消弹出9+1
//       // AppStore.active1ModalVisible = true
//     }
//   }
// }

/**
 * 联系客服
 */
export const getContact = async (orderNo?: string | React.MouseEvent<HTMLElement, MouseEvent>) => {
  const gameNo = typeof orderNo === 'string' ? orderNo : undefined
  const userInfo = UserInfoHS.SuccessResult
  let vipServiceOrder = getVipServiceOrderHS.SuccessResult
  if (!vipServiceOrder) {
    try {
      await getVipServiceOrderHS.Execute()
      vipServiceOrder = getVipServiceOrderHS.SuccessResult
    } catch (e) {}
  }
  if (userInfo && vipServiceOrder) {
    OpenVipCustomerService(gameNo ?? vipServiceOrder)
    return
  }
  const { super_vip_type: superVipType } = userInfo || {}
  if (userInfo?.vip === 2 && superVipType === 'forever') {
    OpenVipCustomerService(gameNo ?? vipServiceOrder ?? undefined)
    return
  }
  OpenCustomerService(undefined, gameNo)
}

/**
 * 联系客服/跳转帮助
 */
export const handleToHelp = (customerSwitch?: string) => {
  if (customerSwitch === '1') {
    history.push('/Help')
    return
  }
  getContact()
}

/** 会到页面顶部 */
export const handleBackTo = (position: number) => {
  const box = document.querySelector('#scrollContent')
  if (box) {
    box.scrollTop = position
  }
}

/**
 * IM域名
 */
export const IMOrigins = {
  dev: 'http://localhost:8000',
  test: 'http://kaihei-im.test.zuhaohao.com',
  pre: 'http://kaihei-im.prd.zuhaohao.com',
  prod: 'https://im.nidiyouxi.com',
}

/**
 * 获取im的链接
 * @param groupHallNo
 * @param needJoinCommunityIds
 * @param joinRoom
 */
export const getIMLink = (groupHallNo: string, needJoinCommunityIds?: string[], joinRoom?: any) => {
  //跳转im的参数
  const params = {
    //来源
    source: '99box',
    //token
    token: getPhpToken(),
    //跳转的社群
    'jump-community-id': groupHallNo,
    //需要加入的社群
    'join-community-ids': (needJoinCommunityIds ?? []).join(','),
    //加入房间的信息
    'join-room': joinRoom && JSON.stringify(joinRoom),
  }
  return `${IMOrigins[process.env.BUILD_TYPE]}/?${stringify(params)}`
}

/**
 * 打开IM
 */
let disposer: Function
export const openIM = throttle(
  async (groupHallNo: string = '', joinRoom?: any) => {
    await isLogged()
    if (!window.FuluApp) {
      needClient()
      return
    }
    const result = await isShowAuthModal(true)
    if (result) {
      return
    }
    const needJoinCommunityIds = await DWgetNeedJoinKaiheiCommunityIdsByUser.Execute()
    // console.log(needJoinCommunityIds, 'needJoinCommunityIds')
    // console.log(
    //   `${
    //     IMOrigins[process.env.BUILD_TYPE]
    //   }/?source=99box&token=${token}&jump-community-id=${groupHallNo}&join-community-ids=${needJoinCommunityIds?.join(
    //     ',',
    //   )}`,
    // )
    const url = getIMLink(groupHallNo, needJoinCommunityIds, joinRoom)
    console.log('im url', url)
    window.FuluApp?.JSNotifyCppFunc('open_window', url, 1160, 730, `${getProductName()}组队开黑工具`, 1, groupHallNo)

    //标记打开状态
    AppStore.imWindowInfo = { status: 'open', closeReason: '' }
    disposer?.()
    //im端打开后，监听关闭消息
    disposer = reaction(
      () => {
        return AppStore.windowClosedInfo.url.includes(IMOrigins[process.env.BUILD_TYPE])
      },
      () => {
        disposer()
        //记录关闭状态及原因
        AppStore.imWindowInfo = {
          status: 'close',
          closeReason: AppStore.windowClosedInfo.reason,
        }
        AppStore.windowClosedInfo = { url: '', reason: '' }
      },
    )
  },
  1000,
  { trailing: false },
)

/** 是否显示红点 */
export const hasUnreadCdkDot = (order: GameOrder) => {
  return (
    [1, 2].includes(order.order_status) &&
    order.account_draw_status === 0 &&
    !!order.threeGoodsFactory &&
    ['weBuff', 'coldLightSpeed'].includes(order.threeGoodsFactory)
  )
}

/**
 * 首次打开，根据渠道配置的game_id、game_library_id跳转详情页
 * 首次打开，根据lid、bid跳转详情页
 * 根据渠道配置的homepage跳转页面
 * @param channelConfigRes
 */
export const checkPageJump = async (channelConfigRes: ChannelConfig) => {
  const notFirstInLoadChannelConfig = localStorage.getItem('notFirstInLoadChannelConfig')
  console.log('initCheck checkPageJump', channelConfigRes, notFirstInLoadChannelConfig)
  if (!notFirstInLoadChannelConfig && channelConfigRes.game_id && channelConfigRes.game_library_id) {
    toStoreGameDetail(channelConfigRes.game_library_id, channelConfigRes.game_id)
    return true
  }
  const clientName = getClientName()
  if (!notFirstInLoadChannelConfig && clientName) {
    let lookGameId: string | null | number = clientName.split('-')[1]
    lookGameId = lookGameId?.includes(lidStr) ? lookGameId.replace(lidStr, '') : null
    console.log('initCheck checkPageJump lookGameId', lookGameId)
    //SEM标识 4749
    if (lookGameId && lookGameId !== '0') {
      try {
        statisticsApiHS.Execute()
      } catch (error) {}
      AppStore.semGameDetailId = Number(lookGameId)
      const { gameLibraryId } = await DWGetGameLibraryInfoByGoodsId.Execute({ goodsId: Number(lookGameId) })
      console.log('initCheck checkPageJump gameLibraryId', gameLibraryId)
      gameLibraryId && toStoreGameDetail(gameLibraryId, Number(lookGameId))
      return true
    }
  }
  if (channelConfigRes.homepage && !process.env.BUILD_TYPE.startsWith('dev')) {
    history.push(channelConfigRes.homepage)
    return true
  }
  return false
}

/**
 * 判读是否永久会员，跳转会员页
 */
const checkForeverVipPageJump = async () => {
  const userInfo = await new Promise<UserInfo | null>(resolve => {
    if (UserInfoHS.SuccessResult) {
      resolve(UserInfoHS.SuccessResult)
    } else {
      const disposer = reaction(
        () => UserInfoHS.SuccessResult,
        v => {
          resolve(v)
          disposer()
        },
      )
    }
  })
  const isForever = userInfo?.vip === 2 && userInfo?.['super_vip_type'] === 'forever'
  console.log('initCheck 永久会员跳转会员页判断 result', isForever)
  if (userInfo?.vip === 2 && userInfo?.['super_vip_type'] === 'forever') {
    commonJump('/vip')
  }
  return isForever
}

/**
 * 初始检测，根据特定参数进行页面跳转，活动弹窗等
 */
export const initCheck = async () => {
  const query = new URLSearchParams(location.search)
  /**
   * 获取当前渠道配置信息（java）,
   * 下一步checkLoginStatus()里面,未登录情况下，会用到返回的enableMacLogin判断是否开启mac登录
   * 不是必须依赖的数据，不用await
   */
  loadChannelConfigJava()

  /** 获取当前渠道配置信息（php）*/
  const loadChannelConfigPhpReq = loadChannelConfigPhp(query.get('ver') || undefined)

  /**
   * 是否登录
   * 是否开启mac登录
   */
  console.log('initCheck MAC静默注册/登录')
  try {
    await checkLoginStatus()
  } catch (e) {
    console.log('checkLoginStatus err', e)
  }

  /** 记录页面是否跳转过 */
  AppStore.isPageJump = false

  /** 配合客户端修改快捷方式需求
   * 根据linkgameid跳转详情页
   * @see https://www.tapd.cn/53495375/prong/stories/view/1153495375001005134?url_cache_key=18077c0c911761c8bb5caaa044e9ee3b&action_entry_type=stories
   */
  console.log('initCheck linkgameid跳转判断')
  try {
    AppStore.isPageJump = !!(await loadLinkGame(query.get('linkgameid')))
    console.log('initCheck linkgameid跳转result', AppStore.isPageJump)
  } catch (e) {
    console.log('loadLinkGame err', e)
  }

  /** 如果已经跳转到了游戏库页面，不需要再做根据game_id、game_library_id等配置的跳转页面逻辑 */
  if (!AppStore.isPageJump) {
    console.log('initCheck gameid等跳转判断')
    try {
      const channelConfigRes = await loadChannelConfigPhpReq
      AppStore.isPageJump = await checkPageJump(channelConfigRes)
    } catch (e) {
      console.log('checkPageJump err', e)
    }
  }
  localStorage.setItem('notFirstInLoadChannelConfig', '1')

  /** 各种活动弹窗 */
  console.log('initCheck 实名、活动弹窗检测')
  await checkModal()
}
